var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1047.39 730.606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 1037.389,
    height: 720.606,
    rx: 28.171,
    ry: 28.171,
    style: {
      fill: "#f3f3fe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.218,730.606H33.171c-18.291,0-33.171-14.881-33.171-33.171V33.171C0,14.88,14.88,0,33.171,0h981.047c18.291,0,33.172,14.88,33.172,33.171v664.264c0,18.29-14.881,33.171-33.172,33.171ZM33.171,10c-12.776,0-23.171,10.395-23.171,23.171v664.264c0,12.776,10.395,23.171,23.171,23.171h981.047c12.777,0,23.172-10.395,23.172-23.171V33.171c0-12.776-10.395-23.171-23.172-23.171H33.171Z",
    style: {
      fill: "#2e303f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166,722.002h43.868s0-711.064,0-711.064H8.864s0,702.527,0,702.527c0,4.715,1.031,8.536,2.303,8.536Z",
    style: {
      fill: "#2e303f"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "42.933 17.646 42.931 17.642 43.077 17.62 43.145 14.932 40.924 16.179 40.082 18.121 42.933 17.646",
    style: {
      fill: "#f2d033"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.996 17.534 43.637 17.923 45.067 22.711 49.319 19.375 47.996 17.534",
    style: {
      fill: "#f2d033"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.773 29.19 26.4 39.541 30.019 29.458 21.773 29.19",
    style: {
      fill: "#f2d033"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.007 45.268 48.439 35.682 43.222 17.918 40.082 18.441 42.059 44.353 44.007 45.268",
    style: {
      fill: "#f2d033"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "42.107 44.995 42.631 51.964 43.828 45.904 43.852 45.815 42.107 44.995",
    style: {
      fill: "#f2d033"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.541 29.871 40.456 28.604 34.584 40.982 41.598 44.122 40.541 29.871",
    style: {
      fill: "#f2d033"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.082 28.083 30.498 29.449 30.065 30.655 29.087 33.379 29.087 33.379 28.633 34.645 26.68 40.088 33.186 40.685 33.186 40.685 34.049 40.8 40.082 28.083",
    style: {
      fill: "#f2d033"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.579 34.749 18.018 34.486 18.117 37.235 18.274 36.804 20.94 29.491 14.579 34.749",
    style: {
      fill: "#f2d033"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.198 52.655 19.962 45.783 18.209 38.158 21.356 29.524 26.052 39.774 21.198 52.655",
    style: {
      fill: "#f2d033"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.45,208.832h-.351c-.878-.336-.411-1.449-.53-2.197-.573-.025-1.163-.362-1.523-.803-.184-.225-1.111-1.773-1.17-1.993-.188-.699.446-1.244,1.056-.818.29.202.825,1.557,1.156,1.942.414.483.933.483,1.483.251,1.234-.519,2.516-1.481,3.767-2.027.51-.407.171-1.225-.473-1.185l-3.18,1.653c-1.624.511-.797-1.236-1.464-2.172-1.116-1.566-3.607-.989-3.773.876-.159,1.788.181,3.858.004,5.636-.043.432-.149.643-.526.835h-.877v-6.512l.361-1.176c1.406-2.893,5.848-2.395,6.39.825,1.33-.377,2.522-1.779,4.02-1.152l3.169-5.052c.623-.599,1.461.133,1.043.871l-3.218,5.047c.277,1.286.099,2.097-1.042,2.819-1.158.733-2.61,1.275-3.797,1.996-.326.748.324,1.863-.525,2.333v.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.584,189.121c1.172.237,1.996,1.105,2.192,2.288-.172,1.871.23,4.164,0,5.984-.216,1.698-1.881,2.524-3.457,2.283-.903-.139-.904-1.258,0-1.397.816-.126,1.605.291,2.036-.772l.021-6.055c-.118-.728-.685-.955-1.358-1.013-3.408-.293-7.238.218-10.689.012-.678.086-1.142.404-1.26,1.111-.06.36.119,1.011-.346,1.148-1.335.393-1.053-1.51-.717-2.214.333-.694,1.154-1.276,1.918-1.375,0,0,11.66,0,11.66,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,196.225c0,1.388-1.121,2.514-2.505,2.514s-2.505-1.126-2.505-2.514,1.121-2.514,2.505-2.514,2.505,1.126,2.505,2.514ZM26.653,196.229c0-.643-.52-1.164-1.16-1.164s-1.16.521-1.16,1.164.52,1.164,1.16,1.164,1.16-.521,1.16-1.164Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.827,192.835l7.611-.02c.892.103.865,1.232,0,1.324l-7.539-.004c-.62-.245-.643-.979-.071-1.3h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.212,196.75c-.136.11-.291.105-.453.118-.882.075-3.016.107-3.857-.011-.689-.097-.652-1.191.089-1.307.611-.096,3.236-.096,3.847,0,.572.09.787.865.375,1.2Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.921,379.746c-.059-.596-.487-1.201-1.037-1.466-.282-.136-.586-.181-.881-.227-.187-.028-.375-.057-.48-.058-.042-.064-.243-.514-.271-.548.718-.888,1.281-1.858.531-2.925-.25-.355-1.434-1.519-1.812-1.715-.271-.139-.553-.211-.836-.211-.361,0-.727.113-1.089.338-.051.031-.694.509-.721.527-.048,0-.206-.078-.299-.126-.106-.052-.208-.101-.298-.131-.028-.132-.052-.265-.074-.397-.095-.552-.193-1.122-.697-1.553-.292-.248-.697-.423-1.057-.453-.25-.023-.606-.033-.965-.033-.362,0-.724.011-.979.031-.583.046-1.17.419-1.464.928-.193.336-.251.712-.307,1.075-.026.169-.052.335-.076.452-.054.03-.504.219-.525.244-.096-.067-.192-.139-.29-.214-.362-.277-.737-.562-1.194-.639-.111-.02-.219-.027-.324-.027-.482,0-.925.186-1.359.572-.323.286-1.287,1.202-1.489,1.637-.479,1.027.052,1.764.565,2.475l.115.161c-.012.032-.026.07-.042.112-.046.124-.154.416-.128.436l-.346.052c-.317.043-.646.087-.945.205-.616.24-1.095.871-1.164,1.531-.053.501-.047,1.515-.004,1.995.054.6.464,1.209.995,1.481.31.158.647.209.972.26.161.025.324.049.483.087l.254.509c-.564.722-1.205,1.54-.699,2.628.209.451,1.196,1.395,1.513,1.668.421.365.872.549,1.377.549h.001c.583-.014,1.027-.341,1.459-.658.1-.074.198-.147.299-.216l.492.195c.052.176.08.357.108.54.053.339.11.69.302,1.009.281.467.852.832,1.391.888.24.026.602.037.968.037.384,0,.771-.012,1.026-.034.46-.037.967-.301,1.264-.653.355-.419.432-.92.508-1.407.018-.119.037-.239.06-.36l.536-.234c.134.083.261.177.388.271.331.244.674.496,1.127.565.102.015.202.022.298.022.482,0,.924-.184,1.354-.565.427-.379,1.438-1.328,1.606-1.966.232-.883-.191-1.462-.637-2.075l-.161-.224.216-.541c.159-.053.342-.075.529-.097.221-.026.447-.054.657-.128.681-.238,1.184-.873,1.252-1.581.049-.514.052-1.534.004-2.02v.002ZM38.115,383.09c-.026.08-.052.158-.08.225s-.065.14-.102.217c-.112.223-.238.476-.219.717.022.275.293.631.556.974.126.165.244.319.31.437.136.243.124.376-.053.593-.165.202-1.1,1.127-1.237,1.2-.067.028-.124.043-.177.043-.102,0-.198-.054-.344-.144-.094-.057-.224-.158-.368-.267-.391-.297-.682-.51-1.004-.554-.243,0-.484.121-.695.227-.076.038-.153.076-.223.105-.062.026-.138.052-.218.079-.248.084-.53.18-.678.342-.187.207-.254.681-.315,1.141-.03.212-.055.408-.092.538-.055.193-.2.313-.407.334-.187.02-.495.028-.807.028-.325,0-.652-.011-.846-.032-.193-.022-.341-.15-.394-.344-.038-.136-.062-.333-.089-.54-.054-.435-.112-.882-.294-1.104-.149-.18-.453-.283-.722-.376l-.208-.075c-.094-.038-.177-.08-.256-.121-.181-.091-.354-.179-.563-.179-.149,0-.302.044-.466.137-.126.071-.291.197-.469.334-.262.202-.623.479-.838.5-.092,0-.182-.041-.294-.131-.271-.218-.887-.834-1.117-1.116-.184-.225-.187-.377-.017-.649.092-.148.206-.293.318-.437s.224-.288.317-.435c.323-.508.169-.803-.009-1.148-.047-.089-.096-.185-.143-.296-.027-.065-.053-.143-.081-.227-.078-.23-.166-.489-.32-.634-.214-.201-.66-.259-1.091-.314-.26-.033-.528-.069-.689-.131-.138-.054-.241-.203-.257-.37-.041-.407-.034-1.239,0-1.636.027-.319.186-.383.569-.461.101-.021.222-.036.351-.052.415-.053.887-.113,1.126-.375.15-.164.209-.362.267-.553.023-.079.047-.159.078-.233s.07-.154.112-.237c.121-.243.257-.517.235-.775-.023-.27-.288-.615-.543-.949-.144-.186-.282-.363-.35-.501-.112-.227-.101-.335.055-.53.214-.265.91-.971,1.164-1.165.089-.068.175-.101.264-.101.09,0,.186.032.298.1.103.064.238.168.382.28.35.271.747.578,1.061.586.195,0,.472-.128.814-.293.087-.042.166-.08.228-.107.064-.027.133-.049.203-.073.191-.062.407-.131.559-.309.177-.207.234-.642.291-1.064.032-.241.062-.474.115-.627.069-.203.186-.294.405-.315.198-.018.531-.028.859-.028.308,0,.612.009.795.031.282.033.345.19.418.54.021.101.039.238.059.387.047.355.101.758.224.956.154.246.442.339.697.42.081.026.161.052.232.081s.15.07.233.112c.243.122.516.259.841.259h.02c.25-.033.583-.29.905-.538.185-.143.362-.281.495-.349.101-.052.181-.076.251-.076.079,0,.158.032.248.103.275.216.967.917,1.178,1.179.195.243.143.372-.054.676-.055.087-.14.197-.233.318-.244.319-.52.68-.556.947-.03.235.102.501.221.738.038.076.075.15.102.216.041.1.073.198.102.291.119.366.232.711.782.833.175.038.363.064.552.087.222.03.445.058.644.113.232.063.33.179.351.409.036.384.042,1.289-.001,1.653-.031.259-.217.357-.367.395-.17.043-.377.067-.585.09-.293.034-.595.07-.825.158-.345.132-.476.525-.581.84h-.006Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.952,376.805c-2.185,0-3.964,1.778-3.964,3.964s1.779,3.966,3.964,3.966,3.966-1.779,3.966-3.966-1.779-3.964-3.966-3.964ZM31.952,383.287c-1.387,0-2.517-1.128-2.517-2.516s1.13-2.517,2.517-2.517,2.516,1.128,2.516,2.517-1.128,2.516-2.516,2.516Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.531,94.159c.391,0,.721.33.721.721v8.197c0,.391-.33.721-.721.721h-2.527c-.391,0-.721-.33-.721-.721v-8.197c0-.391.33-.721.721-.721h2.527M25.531,92.927h-2.527c-1.074,0-1.953.878-1.953,1.953v8.197c0,1.074.878,1.953,1.953,1.953h2.527c1.074,0,1.953-.878,1.953-1.953v-8.197c0-1.074-.878-1.953-1.953-1.953h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.213,89.891c.391,0,.721.33.721.721v12.465c0,.391-.33.721-.721.721h-2.527c-.391,0-.721-.33-.721-.721v-12.465c0-.391.33-.721.721-.721h2.527M33.213,88.659h-2.527c-1.074,0-1.953.878-1.953,1.953v12.465c0,1.074.878,1.953,1.953,1.953h2.527c1.074,0,1.953-.878,1.953-1.953v-12.465c0-1.074-.878-1.953-1.953-1.953h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.894,86.141c.391,0,.721.33.721.721v16.215c0,.391-.33.721-.721.721h-2.527c-.391,0-.721-.33-.721-.721v-16.215c0-.391.33-.721.721-.721h2.527M40.894,84.909h-2.527c-1.074,0-1.953.878-1.953,1.953v16.215c0,1.074.878,1.953,1.953,1.953h2.527c1.074,0,1.953-.878,1.953-1.953v-16.215c0-1.074-.878-1.953-1.953-1.953h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.174,352.453l-.086-.079-6.023-.071-4.301-14.759c-.102-.458-.46-.779-.869-.779-.211,0-.408.089-.542.245-.112.129-.233.365-.169.785l2.198,7.605-2.059-6.485-.062-.055c-.174-.158-.363-.172-.547-.187-.46-.041-.933-.055-1.412-.055-.599,0-1.209.023-1.821.047-.604.023-1.209.046-1.802.046-.389,0-.774-.01-1.195-.041-.27,0-.655.346-.723.62v6.306h-2.574c-.44,0-.652.522-.684.854-.084.936-.046,1.943-.009,2.916.033.891.069,1.811.009,2.654-.028.317.308.679.542.747.152.044.338.064.586.064.217,0,.458-.016.697-.032.225-.015.448-.031.648-.031.067,0,.128,0,.186.005.461.652,1.199,1.037,2.001,1.037.781,0,1.509-.365,1.98-.986l4.058-.032c.038.049.094.136.133.197.094.147.191.297.313.399.335.281.744.429,1.179.429.708,0,1.363-.398,1.693-1.008l1.03.014c.023.063.042.137.062.214.075.298.187.749.726.833l.025.004,6.618-.047.06-.027c.211-.097.354-.297.392-.549.047-.298-.055-.61-.26-.795h.001ZM32.574,351.941c0-.156.128-.283.283-.283s.283.128.283.283-.128.283-.283.283-.283-.128-.283-.283ZM31.118,351.215l-3.511.012c-.018-.076-.033-.153-.051-.228-.091-.424-.185-.864-.57-1.28-.452-.492-1.074-.764-1.751-.764-.722,0-1.438.314-1.913.839-.362.399-.564.898-.588,1.43h-.664v-4.064h4.824c0,.111-.009.237-.017.36-.018.248-.034.504.009.713.025.124.206.376.287.435l.079.057,5.552.052c.043.121.1.324.14.471.111.398.192.681.302.86-.116-.025-.233-.037-.355-.037-.232,0-.472.047-.711.138-.545.207-.801.601-1.051.982l-.016.025h.004ZM28.448,347.222v-.947c0-.163-.366-.681-.614-.681h-2.506v-5.354h4.822l2.12,6.981h-3.823ZM34.248,350.493c.112,0,.625-.017.627-.017l.193.749h-.463c-.163-.303-.362-.552-.59-.74.08.006.159.009.232.009h.001ZM25.173,352.236c-.471,0-.852-.383-.852-.854s.383-.852.852-.852.852.383.852.852-.383.854-.852.854Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.009,235.818c.002-.185-.108-.404-.303-.601-.202-.205-.436-.328-.625-.328h-1.096v-8.643c0-.229-.315-.472-.529-.488-.166.011-.334.016-.505.016-.282,0-.569-.011-.855-.022-.291-.012-.583-.023-.866-.023-.23,0-.456.007-.675.027-.319.027-.46.202-.525.346-.014.034-.06.15-.06.197v8.589h-.825v-5.608c0-.122-.145-.293-.168-.313-.17-.164-.429-.182-.609-.182-.1,0-.202.006-.298.014-.076.005-.15.01-.228.01,0,0-.408-.011-.631-.021-.282-.012-.579-.025-.857-.025-.229,0-.446.009-.641.031-.187.023-.557.193-.557.487v5.608h-8.34c-.191,0-.425.122-.622.324-.2.205-.312.436-.307.631v9.013c.057.52.511.933,1.037.94h18.052c.525-.007.978-.42,1.034-.955v-9.023h-.001ZM34.138,231.357v3.532h-1.945v-3.532s1.945,0,1.945,0ZM32.193,230.322v-.496h1.945v.496h-1.945ZM38.953,228.294v6.595h-1.946v-6.595h1.946ZM37.005,227.261v-.471h1.946v.471h-1.946ZM41.004,235.922v8.85h-18.109v-8.85h18.109Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.967,239.831l15.891.004h.006c.329-.025.596-.27.638-.584.042-.326.025-.696.007-1.053-.015-.287-.027-.574-.014-.876-.065-.294-.297-.499-.622-.535l-15.669-.012c-.216.007-.484.038-.652.222-.11.116-.174.313-.185.446-.039.397-.046,1.335.002,1.751.037.333.249.569.596.638ZM39.498,237.81v.989h-.989v-.989s.989,0,.989,0ZM37.474,237.81v.989h-.989v-.989s.989,0,.989,0ZM35.452,237.81v.989h-.989v-.989s.989,0,.989,0ZM33.427,237.81v.989h-.961v-.989s.961,0,.961,0ZM31.432,237.81v.989h-.989v-.989s.989,0,.989,0ZM29.409,237.81v.989h-.961v-.989s.961,0,.961,0ZM27.413,237.81v.989h-.99v-.989s.99,0,.99,0ZM25.389,237.81v.989h-.989v-.989s.989,0,.989,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.922,240.467c-.23-.022-.466-.03-.706-.03-.29,0-.588.012-.885.023-.294.012-.59.023-.881.023-.245,0-.488-.009-.739-.032l-12.829.026c-.257.06-.467.296-.509.577-.049.349-.049,1.462,0,1.831.048.344.296.585.633.612h.012l15.946-.011c.318-.086.51-.299.54-.6.031-.313.018-.653.005-.994-.012-.286-.025-.573-.009-.88-.063-.313-.28-.517-.579-.545h0ZM35.452,241.475v.989h-.989v-.989s.989,0,.989,0ZM33.427,241.475v.989h-.961v-.989s.961,0,.961,0ZM31.432,241.475v.989h-.989v-.989s.989,0,.989,0ZM29.409,241.475v.989h-.961v-.989s.961,0,.961,0ZM27.414,241.475v.989h-.992v-.989s.992,0,.992,0ZM25.389,241.475v.989h-.989v-.989s.989,0,.989,0ZM38.509,242.463v-.989h.989v.989s-.989,0-.989,0ZM36.486,242.463v-.989h.989v.989s-.989,0-.989,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.007,273.094c.062,0,.117.055.117.117v1.699c0,.062-.055.117-.117.117h-2.065c-.062,0-.117-.055-.117-.117v-1.699c0-.062.055-.117.117-.117h2.065M27.007,271.862h-2.065c-.742,0-1.349.607-1.349,1.349v1.699c0,.742.607,1.349,1.349,1.349h2.065c.742,0,1.349-.607,1.349-1.349v-1.699c0-.742-.607-1.349-1.349-1.349h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.982,273.094c.062,0,.117.055.117.117v1.699c0,.062-.055.117-.117.117h-2.065c-.062,0-.117-.055-.117-.117v-1.699c0-.062.055-.117.117-.117h2.065M32.982,271.862h-2.065c-.742,0-1.349.607-1.349,1.349v1.699c0,.742.607,1.349,1.349,1.349h2.065c.742,0,1.349-.607,1.349-1.349v-1.699c0-.742-.607-1.349-1.349-1.349h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.958,273.094c.062,0,.117.055.117.117v1.699c0,.062-.055.117-.117.117h-2.065c-.062,0-.117-.055-.117-.117v-1.699c0-.062.055-.117.117-.117h2.065M38.958,271.862h-2.065c-.742,0-1.349.607-1.349,1.349v1.699c0,.742.607,1.349,1.349,1.349h2.065c.742,0,1.349-.607,1.349-1.349v-1.699c0-.742-.607-1.349-1.349-1.349h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.007,278.432c.062,0,.117.055.117.117v1.699c0,.062-.055.117-.117.117h-2.065c-.062,0-.117-.055-.117-.117v-1.699c0-.062.055-.117.117-.117h2.065M27.007,277.2h-2.065c-.742,0-1.349.607-1.349,1.349v1.699c0,.742.607,1.349,1.349,1.349h2.065c.742,0,1.349-.607,1.349-1.349v-1.699c0-.742-.607-1.349-1.349-1.349h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.982,278.432c.062,0,.117.055.117.117v1.699c0,.062-.055.117-.117.117h-2.065c-.062,0-.117-.055-.117-.117v-1.699c0-.062.055-.117.117-.117h2.065M32.982,277.2h-2.065c-.742,0-1.349.607-1.349,1.349v1.699c0,.742.607,1.349,1.349,1.349h2.065c.742,0,1.349-.607,1.349-1.349v-1.699c0-.742-.607-1.349-1.349-1.349h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.958,278.432c.062,0,.117.055.117.117v1.699c0,.062-.055.117-.117.117h-2.065c-.062,0-.117-.055-.117-.117v-1.699c0-.062.055-.117.117-.117h2.065M38.958,277.2h-2.065c-.742,0-1.349.607-1.349,1.349v1.699c0,.742.607,1.349,1.349,1.349h2.065c.742,0,1.349-.607,1.349-1.349v-1.699c0-.742-.607-1.349-1.349-1.349h0Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M40.895,264.07h-2.203v-.885c0-.272-.221-.494-.494-.494s-.494.221-.494.494v.885h-11.51v-.885c0-.272-.221-.494-.494-.494s-.494.221-.494.494v.885h-2.203c-1.074,0-1.953.878-1.953,1.953v16.215c0,1.074.878,1.953,1.953,1.953h17.891c1.074,0,1.953-.878,1.953-1.953v-16.215c0-1.074-.878-1.953-1.953-1.953ZM23.005,265.302h2.203v1.109c0,.272.221.494.494.494s.494-.221.494-.494v-1.109h11.512v1.109c0,.272.221.494.494.494s.494-.221.494-.494v-1.109h2.203c.391,0,.721.33.721.721v3.295h-19.335v-3.295c0-.391.33-.721.721-.721ZM40.895,282.958h-17.89c-.391,0-.721-.33-.721-.721v-11.687h19.333v11.687c0,.391-.33.721-.721.721h-.001Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.239,305.365c-.228-1.209-1.174-2.216-2.353-2.503-.381-.094-.769-.106-1.066-.106-.166,0-.825.018-.987.018-.07,0-.139,0-.208-.004-.142-.902-.904-1.589-1.86-1.656-.317-.022-.641-.028-.97-.028-.455,0-.918.016-1.377.03-.451.015-.899.03-1.335.03h-.197c-.827.136-1.487.806-1.615,1.621l-1.088-.011c-.621,0-1.284.048-1.922.398-1.013.556-1.636,1.603-1.667,2.806.016,1.436.007,2.874,0,4.312-.012,2.284-.025,4.647.063,6.99.257,1.348,1.343,2.38,2.718,2.571,1.855.025,3.714.036,5.573.036s3.718-.012,5.592-.037c1.566-.214,2.753-1.585,2.763-3.193-.016-1.433-.007-2.867,0-4.301.012-2.282.025-4.638-.063-6.974h-.001ZM29.703,302.849c.084-.175.266-.293.478-.313.267-.023.542-.03.822-.03.352,0,.712.012,1.072.026.362.014.726.026,1.083.026.222,0,.441-.005.615-.022.196.046.426.198.467.429.032.174.032.87,0,1.02-.052.254-.322.411-.548.432-.259.022-.524.03-.795.03-.342,0-.692-.014-1.042-.026-.354-.012-.707-.026-1.055-.026-.225,0-.448.006-.641.021-.118-.014-.307-.11-.379-.193-.046-.053-.119-.209-.129-.273-.043-.273-.033-.919.053-1.1ZM37.262,318.444h-10.613c-.887-.086-1.574-.795-1.634-1.671v-10.909c.052-.893.753-1.615,1.63-1.679.127-.01.256-.014.387-.014.171,0,.344.006.516.011.177.006.354.012.527.012.067,0,.132,0,.197-.002.147.891.908,1.571,1.876,1.642.212-.01.426-.015.642-.015.346,0,.696.011,1.047.021.354.01.706.02,1.055.02.276,0,.549-.006.82-.023.988-.063,1.754-.732,1.909-1.645.067.002.133.002.201.002.177,0,.356-.006.536-.012.176-.006.351-.012.525-.012.133,0,.265.004.393.014.852.069,1.557.806,1.604,1.672v10.908c-.059.889-.745,1.597-1.619,1.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.495,302.913c.77.041,1.605-.092,2.355.091,1.138.278,2.028,1.243,2.243,2.389.138,3.741.02,7.5.06,11.249-.009,1.523-1.121,2.838-2.635,3.045-3.709.049-7.433.049-11.143,0-1.291-.18-2.33-1.173-2.575-2.452-.137-3.75-.02-7.517-.06-11.275.03-1.12.605-2.136,1.589-2.676.971-.532,2.006-.339,3.07-.372.068-.804.711-1.491,1.508-1.62,1.244.012,2.608-.116,3.845-.031.901.062,1.658.74,1.739,1.65h.002ZM29.667,304.317c.1.116.322.228.476.245,1.151-.075,2.424.099,3.56,0,.302-.026.617-.239.681-.549.037-.176.033-.894,0-1.075-.051-.281-.31-.484-.579-.546-1.174.071-2.477-.103-3.637-.004-.251.022-.488.166-.599.397s-.108.92-.065,1.186c.015.094.102.275.164.346h-.001ZM28.402,304.037c-.575.033-1.197-.043-1.768,0-.958.071-1.711.867-1.767,1.818v10.916c.065.968.804,1.723,1.767,1.818h10.628c.961-.092,1.703-.854,1.767-1.818v-10.916c-.051-.931-.804-1.744-1.741-1.818-.577-.046-1.211.036-1.794,0-.095.942-.861,1.592-1.791,1.65-1.159.073-2.394-.057-3.56-.001-.897-.067-1.658-.743-1.741-1.648Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.471,309.167c.806-.023,1.248.882.753,1.525-1.707,1.306-3.336,2.835-5.061,4.104-.641.472-1.029.504-1.583-.108-.546-.602-1.471-1.764-1.905-2.439-.674-1.052.462-2.006,1.381-1.252l1.498,1.881,4.456-3.573c.126-.073.318-.134.46-.139h.001Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.654,130.578c1.234-.859,2.046-2.283,2.046-3.9,0-2.624-2.128-4.752-4.752-4.752s-4.752,2.128-4.752,4.752c0,1.618.812,3.042,2.046,3.9-4.154,1.181-7.208,5-7.208,9.528h1.232c0-4.776,3.878-8.662,8.651-8.679.011,0,.02.004.031.004s.02-.002.031-.004c4.773.017,8.651,3.903,8.651,8.679h1.232c0-4.527-3.054-8.346-7.208-9.528ZM28.429,126.679c0-1.94,1.579-3.52,3.52-3.52s3.52,1.579,3.52,3.52c0,1.93-1.563,3.5-3.489,3.517-.01,0-.02-.001-.031-.001s-.02.001-.031.001c-1.927-.017-3.489-1.587-3.489-3.517Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.433,160.21c.391,0,.721.33.721.721v9.341c0,.391-.33.721-.721.721h-16.969c-.391,0-.721-.33-.721-.721v-9.341c0-.391.33-.721.721-.721h16.969M40.433,158.978h-16.969c-1.074,0-1.953.878-1.953,1.953v9.341c0,1.074.878,1.953,1.953,1.953h16.969c1.074,0,1.953-.878,1.953-1.953v-9.341c0-1.074-.878-1.953-1.953-1.953h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.433,
    y: 166.13,
    width: 3.033,
    height: 0.511,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.433,
    y: 164.411,
    width: 3.033,
    height: 0.487,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.466,166.641h-3.033v-.511h-1.232v.638c0,.609.498,1.106,1.106,1.106h3.286c.609,0,1.106-.498,1.106-1.106v-.638h-1.232v.511h-.001Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.26,164.898c-1.375,0-2.492-1.131-2.492-2.521h-1.232c0,2.07,1.671,3.752,3.724,3.752h3.941v-1.232s-3.941,0-3.941,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.131,162.377c0,1.39-1.119,2.521-2.492,2.521h-3.941v1.232h3.941c2.054,0,3.724-1.684,3.724-3.752,0,0-1.232,0-1.232,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.591,163.179h-3.286c-.609,0-1.106.498-1.106,1.106v1.845h1.232v-1.719h3.033v1.719h1.232v-1.845c0-.609-.498-1.106-1.106-1.106h.001Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.317,158.234h-4.736c-.391,0-.721.33-.721.721v.849h6.177v-.849c0-.391-.33-.721-.721-.721Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.861,158.955c0-.391.33-.721.721-.721h4.736c.391,0,.721.33.721.721v.849h1.232v-.849c0-1.074-.878-1.953-1.953-1.953h-4.736c-1.074,0-1.953.878-1.953,1.953v.849h1.232v-.849Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.91,
    y: 62.725,
    width: 957.77,
    height: 35.858,
    style: {
      fill: "#f2f2f2"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.528,84.898v-10.05h1.356l6.118,6.704v-6.704h1.959v10.05h-1.356l-6.118-6.721v6.721h-1.959Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.983,78.374h1.838v6.524h-1.838v-.843c-.663.949-1.536,1.054-2.004,1.054-2.004,0-3.331-1.567-3.331-3.48,0-1.928,1.311-3.468,3.24-3.468.498,0,1.477.092,2.094,1.056v-.843h.002ZM96.547,81.629c0,1.04.752,1.852,1.807,1.852s1.809-.814,1.809-1.852-.753-1.84-1.809-1.84-1.807.798-1.807,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.568,78.374h1.838v.738c.693-.874,1.553-.95,1.944-.95,1.372,0,1.899.859,2.065,1.19.316-.511.964-1.19,2.094-1.19,1.009,0,1.507.466,1.762.798.422.558.453,1.116.453,1.84v4.098h-1.838v-3.556c0-.769-.166-1.114-.301-1.28-.242-.302-.572-.332-.753-.332-.498,0-.814.225-1.009.572-.242.392-.257.917-.257,1.266v3.329h-1.838v-3.556c0-.769-.166-1.114-.301-1.28-.242-.302-.574-.332-.753-.332-.498,0-.814.225-1.009.572-.242.392-.257.917-.257,1.266v3.329h-1.838v-6.524h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.875,83.075c-.195.484-.935,2.034-3.208,2.034-1.056,0-1.854-.301-2.502-.917-.724-.679-1.025-1.522-1.025-2.547,0-1.296.527-2.094.995-2.562.769-.753,1.672-.919,2.455-.919,1.327,0,2.094.527,2.547,1.071.693.829.784,1.852.784,2.562v.15h-4.883c0,.392.105.814.316,1.101.195.271.603.619,1.311.619.693,0,1.22-.332,1.522-.859l1.688.271-.002-.003ZM120.189,80.77c-.15-.89-.874-1.311-1.552-1.311s-1.387.439-1.536,1.311h3.087Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M247.022,74.847v8.362h3.105v1.688h-5.064v-10.05h1.959Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.254,79.082c.648.587,1.101,1.493,1.101,2.562,0,1.056-.453,1.959-1.101,2.547-.558.511-1.401.917-2.637.917s-2.078-.406-2.637-.917c-.648-.587-1.101-1.493-1.101-2.547,0-1.069.453-1.973,1.101-2.562.558-.511,1.401-.919,2.637-.919s2.078.408,2.637.919ZM256.456,81.643c0-1.025-.784-1.854-1.838-1.854s-1.838.829-1.838,1.854c0,.995.769,1.838,1.838,1.838s1.838-.843,1.838-1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.681,80.364c-.392-.361-.874-.574-1.507-.574-1.222,0-1.838.89-1.838,1.84,0,1.069.798,1.852,1.899,1.852.408,0,.949-.119,1.446-.572v1.793c-.361.181-.935.406-1.688.406-1.025,0-1.928-.39-2.516-.949-.496-.466-1.04-1.282-1.04-2.502,0-1.146.467-2.065,1.13-2.652.798-.708,1.719-.845,2.351-.845.677,0,1.235.136,1.762.392v1.809h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.071,78.374h1.838v6.524h-1.838v-.843c-.663.949-1.536,1.054-2.004,1.054-2.004,0-3.329-1.567-3.329-3.48,0-1.928,1.31-3.468,3.24-3.468.498,0,1.477.092,2.094,1.056v-.843ZM267.636,81.629c0,1.04.753,1.852,1.807,1.852s1.809-.814,1.809-1.852-.753-1.84-1.809-1.84-1.807.798-1.807,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.496,79.941v4.957h-1.838v-4.957h-.724v-1.567h.724v-2.231h1.838v2.231h1.266v1.567h-1.266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.646,74.517c.603,0,1.101.498,1.101,1.101s-.498,1.101-1.101,1.101-1.101-.498-1.101-1.101.498-1.101,1.101-1.101ZM280.563,78.374v6.524h-1.838v-6.524h1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.355,79.082c.648.587,1.101,1.493,1.101,2.562,0,1.056-.453,1.959-1.101,2.547-.558.511-1.401.917-2.637.917s-2.078-.406-2.637-.917c-.648-.587-1.101-1.493-1.101-2.547,0-1.069.453-1.973,1.101-2.562.558-.511,1.401-.919,2.637-.919s2.078.408,2.637.919ZM287.555,81.643c0-1.025-.784-1.854-1.838-1.854s-1.838.829-1.838,1.854c0,.995.769,1.838,1.838,1.838s1.838-.843,1.838-1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.869,78.374h1.838v.843c.347-.482.964-1.056,2.018-1.056.574,0,1.417.166,1.928.798.453.558.513,1.206.513,1.84v4.098h-1.838v-3.556c0-.361-.016-.935-.347-1.28-.287-.302-.679-.332-.859-.332-.482,0-.859.166-1.13.572-.271.422-.287.89-.287,1.266v3.329h-1.838v-6.524h.002Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M949.701,82.79h-4.053l-.89,2.11h-2.125l4.325-10.05h1.536l4.205,10.05h-2.11l-.888-2.11ZM949.127,81.192l-1.431-3.616-1.431,3.616h2.863-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.516,80.364c-.392-.361-.874-.574-1.508-.574-1.22,0-1.838.89-1.838,1.84,0,1.069.798,1.852,1.899,1.852.406,0,.95-.119,1.448-.572v1.793c-.361.181-.935.406-1.688.406-1.025,0-1.928-.39-2.517-.949-.498-.466-1.04-1.282-1.04-2.502,0-1.146.467-2.065,1.13-2.652.798-.708,1.719-.845,2.352-.845.677,0,1.235.136,1.762.392v1.809h.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.89,79.941v4.957h-1.838v-4.957h-.724v-1.567h.724v-2.231h1.838v2.231h1.266v1.567h-1.266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.04,74.517c.603,0,1.101.498,1.101,1.101s-.498,1.101-1.101,1.101-1.101-.498-1.101-1.101.498-1.101,1.101-1.101ZM965.957,78.374v6.524h-1.838v-6.524h1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.749,79.082c.648.587,1.101,1.493,1.101,2.562,0,1.056-.453,1.959-1.101,2.547-.558.511-1.401.917-2.638.917s-2.078-.406-2.637-.917c-.648-.587-1.101-1.493-1.101-2.547,0-1.069.453-1.973,1.101-2.562.558-.511,1.401-.919,2.637-.919s2.08.408,2.638.919ZM972.949,81.643c0-1.025-.784-1.854-1.84-1.854s-1.838.829-1.838,1.854c0,.995.769,1.838,1.838,1.838s1.84-.843,1.84-1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.263,78.374h1.838v.843c.347-.482.964-1.056,2.02-1.056.572,0,1.417.166,1.928.798.453.558.511,1.206.511,1.84v4.098h-1.838v-3.556c0-.361-.014-.935-.346-1.28-.287-.302-.679-.332-.859-.332-.484,0-.859.166-1.13.572-.271.422-.287.89-.287,1.266v3.329h-1.838v-6.524Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M807.442,77.138c-.587-.784-1.282-.859-1.643-.859-1.054,0-1.386.663-1.386,1.175,0,.24.074.466.316.679.242.225.572.346,1.206.572.783.271,1.52.543,2.034,1.009.451.406.859,1.085.859,2.11,0,1.958-1.417,3.3-3.497,3.3-1.852,0-2.937-1.13-3.466-1.899l1.282-1.222c.482.978,1.401,1.341,2.11,1.341.89,0,1.553-.543,1.553-1.386,0-.361-.121-.648-.392-.905-.377-.346-.978-.543-1.553-.738-.527-.18-1.161-.422-1.672-.874-.332-.287-.798-.843-.798-1.868,0-1.477.995-2.954,3.224-2.954.632,0,1.823.121,2.849,1.175l-1.025,1.342v.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.112,78.374v3.692c0,.346.031.814.392,1.144.226.195.587.332.935.332s.708-.135.935-.332c.361-.332.392-.798.392-1.144v-3.692h1.838v3.993c0,.587-.074,1.37-.798,2.004-.603.527-1.567.738-2.365.738s-1.762-.211-2.365-.738c-.724-.632-.798-1.415-.798-2.004v-3.993h1.838-.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.19,88.35h-1.838v-9.974h1.838v.843c.287-.406.919-1.056,2.125-1.056.572,0,1.493.136,2.231.874.484.482.98,1.296.98,2.592,0,1.475-.648,2.275-1.025,2.637-.498.466-1.251.843-2.215.843-.451,0-1.37-.074-2.094-1.054v4.293l-.002.002ZM820.627,80.228c-.406.346-.617.798-.617,1.401s.24,1.101.603,1.415c.24.213.632.437,1.204.437.603,0,.995-.24,1.235-.466.392-.361.574-.904.574-1.386s-.195-1.025-.558-1.372c-.332-.301-.814-.466-1.251-.466-.482,0-.859.135-1.19.439v-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.778,88.35h-1.838v-9.974h1.838v.843c.287-.406.919-1.056,2.125-1.056.572,0,1.493.136,2.231.874.484.482.98,1.296.98,2.592,0,1.475-.648,2.275-1.025,2.637-.498.466-1.251.843-2.215.843-.451,0-1.37-.074-2.094-1.054v4.293l-.002.002ZM829.214,80.228c-.406.346-.617.798-.617,1.401s.24,1.101.603,1.415c.24.213.632.437,1.204.437.603,0,.995-.24,1.235-.466.392-.361.574-.904.574-1.386s-.195-1.025-.558-1.372c-.332-.301-.814-.466-1.251-.466-.482,0-.859.135-1.19.439v-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.571,79.082c.648.587,1.101,1.493,1.101,2.562,0,1.056-.453,1.959-1.101,2.547-.558.511-1.401.917-2.638.917s-2.078-.406-2.637-.917c-.648-.587-1.101-1.493-1.101-2.547,0-1.069.453-1.973,1.101-2.562.558-.511,1.401-.919,2.637-.919s2.08.408,2.638.919ZM840.773,81.643c0-1.025-.784-1.854-1.84-1.854s-1.838.829-1.838,1.854c0,.995.769,1.838,1.838,1.838s1.84-.843,1.84-1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.088,78.374h1.838v.978c.285-.558.677-.829.814-.904.287-.18.648-.287,1.085-.287.316,0,.572.076.783.152l-.24,1.719c-.24-.166-.482-.242-.859-.242-.346,0-.857.076-1.22.527-.347.437-.361.995-.361,1.448v3.134h-1.838v-6.524l-.002-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.816,79.941v4.957h-1.838v-4.957h-.724v-1.567h.724v-2.231h1.838v2.231h1.266v1.567h-1.266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.966,74.517c.603,0,1.101.498,1.101,1.101s-.498,1.101-1.101,1.101-1.101-.498-1.101-1.101.498-1.101,1.101-1.101ZM855.885,78.374v6.524h-1.838v-6.524h1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.634,78.374h1.838v.843c.346-.482.964-1.056,2.02-1.056.572,0,1.415.166,1.928.798.451.558.511,1.206.511,1.84v4.098h-1.838v-3.556c0-.361-.016-.935-.347-1.28-.285-.302-.677-.332-.859-.332-.482,0-.857.166-1.13.572-.271.422-.285.89-.285,1.266v3.329h-1.838v-6.524Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.652,78.374h1.838v6.223c0,.995-.09,2.034-.904,2.849-.451.451-1.235.917-2.576.917-1.266,0-2.02-.377-2.441-.752-.511-.439-.904-1.206-1.054-1.945h1.987c.076.301.242.603.453.784.361.332.859.346,1.114.346.527,0,.874-.18,1.116-.406.422-.406.466-.919.466-1.448v-.917c-.632.964-1.507,1.083-2.004,1.083-.874,0-1.628-.271-2.26-.888-.484-.484-1.04-1.327-1.04-2.592,0-1.025.377-1.975,1.009-2.592.572-.558,1.37-.874,2.244-.874,1.222,0,1.793.663,2.049,1.056v-.843l.002-.002ZM867.833,80.241c-.301.271-.587.708-.587,1.387,0,.572.211.995.482,1.28.392.422.89.572,1.327.572.453,0,.904-.166,1.222-.451.377-.347.587-.874.587-1.401,0-.619-.271-1.04-.525-1.311-.361-.377-.784-.527-1.282-.527-.587,0-.995.242-1.222.453l-.002-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.355,76.537h-3.374v2.244h3.164v1.688h-3.164v4.43h-1.959v-10.05h5.334v1.688Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.689,74.517c.603,0,1.101.498,1.101,1.101s-.498,1.101-1.101,1.101-1.101-.498-1.101-1.101.498-1.101,1.101-1.101ZM886.608,78.374v6.524h-1.838v-6.524h1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.193,73.914v10.983h-1.838v-10.983h1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.347,83.075c-.195.484-.935,2.034-3.21,2.034-1.056,0-1.854-.301-2.502-.917-.724-.679-1.025-1.522-1.025-2.547,0-1.296.527-2.094.995-2.562.769-.753,1.672-.919,2.457-.919,1.327,0,2.094.527,2.545,1.071.693.829.784,1.852.784,2.562v.15h-4.883c0,.392.105.814.318,1.101.195.271.603.619,1.31.619.693,0,1.222-.332,1.522-.859l1.688.271v-.003ZM896.659,80.77c-.152-.89-.874-1.311-1.553-1.311s-1.386.439-1.536,1.311h3.089Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.364,79.925c-.437-.406-.874-.437-1.07-.437-.437,0-.708.213-.708.527,0,.166.074.422.587.587l.437.135c.511.166,1.28.422,1.657.935.195.271.332.663.332,1.085,0,.587-.195,1.175-.724,1.657-.527.484-1.161.693-1.959.693-1.356,0-2.125-.648-2.531-1.083l.964-1.116c.361.422.904.753,1.446.753.513,0,.905-.257.905-.708,0-.408-.332-.574-.574-.663l-.422-.152c-.467-.166-1.011-.377-1.403-.783-.301-.318-.496-.724-.496-1.251,0-.632.301-1.161.677-1.477.511-.406,1.175-.466,1.702-.466.484,0,1.251.06,2.08.693l-.905,1.069.003.003Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M656.801,74.847c1.13,0,1.914.119,2.652.769.814.724,1.025,1.702,1.025,2.426,0,.392-.06,1.475-.829,2.244-.558.558-1.387.89-2.547.89h-1.266v3.722h-1.959v-10.05h2.925ZM655.837,79.488h.798c.377,0,.859,0,1.282-.316.361-.287.543-.738.543-1.177,0-.556-.271-.935-.558-1.144-.406-.287-.917-.316-1.387-.316h-.677v2.953Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.907,83.075c-.195.484-.935,2.034-3.208,2.034-1.056,0-1.854-.301-2.502-.917-.722-.679-1.023-1.522-1.023-2.547,0-1.296.525-2.094.993-2.562.771-.753,1.674-.919,2.457-.919,1.327,0,2.094.527,2.547,1.071.693.829.783,1.852.783,2.562v.15h-4.881c0,.392.105.814.316,1.101.195.271.603.619,1.311.619.691,0,1.22-.332,1.52-.859l1.688.271-.002-.003ZM666.219,80.77c-.15-.89-.874-1.311-1.552-1.311s-1.387.439-1.538,1.311h3.089Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.369,78.374h1.838v.978c.287-.558.679-.829.814-.904.285-.18.648-.287,1.083-.287.318,0,.574.076.784.152l-.24,1.719c-.242-.166-.484-.242-.859-.242-.347,0-.859.076-1.222.527-.346.437-.361.995-.361,1.448v3.134h-1.838v-6.526Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.184,79.925c-.437-.406-.874-.437-1.069-.437-.437,0-.708.213-.708.527,0,.166.074.422.587.587l.437.135c.513.166,1.282.422,1.657.935.195.271.332.663.332,1.085,0,.587-.195,1.175-.724,1.657-.525.484-1.161.693-1.959.693-1.355,0-2.123-.648-2.531-1.083l.964-1.116c.361.422.905.753,1.448.753.511,0,.904-.257.904-.708,0-.408-.332-.574-.572-.663l-.422-.152c-.466-.166-1.009-.377-1.401-.783-.301-.318-.498-.724-.498-1.251,0-.632.301-1.161.677-1.477.513-.406,1.177-.466,1.704-.466.482,0,1.249.06,2.078.693l-.904,1.069v.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.757,79.082c.648.587,1.101,1.493,1.101,2.562,0,1.056-.453,1.959-1.101,2.547-.558.511-1.401.917-2.638.917s-2.078-.406-2.637-.917c-.648-.587-1.101-1.493-1.101-2.547,0-1.069.453-1.973,1.101-2.562.558-.511,1.401-.919,2.637-.919s2.08.408,2.638.919ZM685.959,81.643c0-1.025-.784-1.854-1.84-1.854s-1.838.829-1.838,1.854c0,.995.769,1.838,1.838,1.838s1.84-.843,1.84-1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.274,78.374h1.838v.843c.346-.482.964-1.056,2.02-1.056.572,0,1.415.166,1.928.798.451.558.511,1.206.511,1.84v4.098h-1.838v-3.556c0-.361-.016-.935-.347-1.28-.285-.302-.677-.332-.859-.332-.482,0-.857.166-1.13.572-.271.422-.285.89-.285,1.266v3.329h-1.838v-6.524Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.01,74.847c1.386,0,2.094.361,2.562.752.769.648.995,1.508.995,2.26,0,.98-.392,1.84-1.177,2.367-.256.18-.617.346-1.101.437l3.134,4.233h-2.44l-2.683-4.038h-.24v4.038h-1.959v-10.05h2.91l-.002.002ZM703.06,79.474h.558c.377,0,1.928-.045,1.928-1.522,0-1.493-1.536-1.507-1.899-1.507h-.587v3.029Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.883,83.075c-.195.484-.935,2.034-3.21,2.034-1.056,0-1.854-.301-2.502-.917-.724-.679-1.025-1.522-1.025-2.547,0-1.296.527-2.094.995-2.562.769-.753,1.672-.919,2.457-.919,1.327,0,2.094.527,2.545,1.071.693.829.784,1.852.784,2.562v.15h-4.883c0,.392.105.814.318,1.101.195.271.603.619,1.31.619.693,0,1.222-.332,1.522-.859l1.688.271v-.003ZM714.195,80.77c-.152-.89-.874-1.311-1.553-1.311s-1.386.439-1.536,1.311h3.089Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.183,88.35h-1.838v-9.974h1.838v.843c.285-.406.917-1.056,2.125-1.056.572,0,1.493.136,2.231.874.482.482.978,1.296.978,2.592,0,1.475-.648,2.275-1.025,2.637-.498.466-1.249.843-2.213.843-.453,0-1.37-.074-2.094-1.054v4.293l-.002.002ZM719.62,80.228c-.406.346-.619.798-.619,1.401s.242,1.101.605,1.415c.24.213.632.437,1.204.437.603,0,.995-.24,1.235-.466.392-.361.572-.904.572-1.386s-.195-1.025-.558-1.372c-.332-.301-.814-.466-1.249-.466-.484,0-.859.135-1.19.439v-.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.976,79.082c.648.587,1.101,1.493,1.101,2.562,0,1.056-.451,1.959-1.101,2.547-.558.511-1.401.917-2.637.917s-2.08-.406-2.637-.917c-.648-.587-1.101-1.493-1.101-2.547,0-1.069.451-1.973,1.101-2.562.556-.511,1.401-.919,2.637-.919s2.078.408,2.637.919ZM731.177,81.643c0-1.025-.783-1.854-1.838-1.854s-1.838.829-1.838,1.854c0,.995.769,1.838,1.838,1.838s1.838-.843,1.838-1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.491,78.374h1.838v.978c.287-.558.679-.829.814-.904.285-.18.648-.287,1.083-.287.318,0,.574.076.784.152l-.24,1.719c-.242-.166-.484-.242-.859-.242-.347,0-.859.076-1.222.527-.346.437-.361.995-.361,1.448v3.134h-1.838v-6.526Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.221,79.941v4.957h-1.838v-4.957h-.724v-1.567h.724v-2.231h1.838v2.231h1.266v1.567h-1.266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.371,74.517c.603,0,1.101.498,1.101,1.101s-.498,1.101-1.101,1.101-1.101-.498-1.101-1.101.498-1.101,1.101-1.101ZM746.288,78.374v6.524h-1.838v-6.524h1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.037,78.374h1.838v.843c.347-.482.964-1.056,2.02-1.056.572,0,1.417.166,1.928.798.453.558.511,1.206.511,1.84v4.098h-1.838v-3.556c0-.361-.014-.935-.346-1.28-.287-.302-.679-.332-.859-.332-.484,0-.859.166-1.13.572-.271.422-.287.89-.287,1.266v3.329h-1.838v-6.524Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.056,78.374h1.838v6.223c0,.995-.09,2.034-.904,2.849-.451.451-1.235.917-2.576.917-1.266,0-2.02-.377-2.441-.752-.511-.439-.904-1.206-1.054-1.945h1.987c.076.301.242.603.453.784.361.332.859.346,1.114.346.527,0,.874-.18,1.116-.406.422-.406.466-.919.466-1.448v-.917c-.632.964-1.507,1.083-2.004,1.083-.874,0-1.628-.271-2.26-.888-.484-.484-1.04-1.327-1.04-2.592,0-1.025.377-1.975,1.009-2.592.572-.558,1.37-.874,2.244-.874,1.222,0,1.793.663,2.049,1.056v-.843l.002-.002ZM758.238,80.241c-.301.271-.587.708-.587,1.387,0,.572.211.995.482,1.28.392.422.89.572,1.327.572.453,0,.904-.166,1.222-.451.377-.347.587-.874.587-1.401,0-.619-.271-1.04-.525-1.311-.361-.377-.784-.527-1.282-.527-.587,0-.995.242-1.222.453l-.002-.002Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 339.63,
    y: 103.452,
    width: 135.987,
    height: 26.668,
    style: {
      fill: "#8cc640"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.63,
    y: 134.759,
    width: 135.987,
    height: 26.668,
    style: {
      fill: "#6c757d"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.63,
    y: 166.066,
    width: 135.987,
    height: 26.668,
    style: {
      fill: "#8cc640"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.63,
    y: 197.371,
    width: 135.987,
    height: 26.668,
    style: {
      fill: "#8cc640"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.63,
    y: 228.678,
    width: 135.987,
    height: 26.668,
    style: {
      fill: "#f1ba1b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.63,
    y: 259.985,
    width: 135.987,
    height: 26.668,
    style: {
      fill: "#6c757d"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M385.904,109.456c.679-.047,1.868-.009,2.502.235.505.194.631.719.28,1.133-.384.454-.819.2-1.315.142-2.236-.257-4.14.442-5.527,2.22-2.161,2.77-1.384,6.799,1.588,8.615,3.689,2.256,8.45-.123,8.922-4.38.047-.423-.073-.955.316-1.235.368-.264,1.044-.111,1.102.377.164,1.36-.52,3.259-1.282,4.373-3.513,5.137-11.453,3.849-13.086-2.175-1.19-4.399,1.932-8.988,6.5-9.306v.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.385,112.454c.674-.138,1.185.548.796,1.142l-5.01,5.747c-.268.347-.629.511-1.05.29l-2.443-2.452c-.352-.563.152-1.239.796-1.108.138.028.361.221.473.32.523.454,1.018,1.03,1.534,1.5l4.585-5.24c.071-.076.219-.178.318-.199h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M404.555,111.524c2.567,0,4.074,1.966,4.074,4.534s-1.507,4.494-4.074,4.494h-3.499v-9.028h3.499ZM404.555,119.451c1.899,0,2.882-1.469,2.882-3.393s-.983-3.431-2.882-3.431h-2.307v6.825h2.307Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.936,116.058c0-2.567,1.99-4.689,4.56-4.689s4.585,2.122,4.585,4.689-2.004,4.651-4.585,4.651-4.56-2.096-4.56-4.651ZM417.887,116.058c0-1.939-1.467-3.59-3.393-3.59-1.901,0-3.366,1.652-3.366,3.59,0,1.925,1.467,3.551,3.366,3.551,1.925,0,3.393-1.624,3.393-3.551Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.292,111.524h1.192v9.028h-1.152l-4.166-6.878v6.878h-1.192v-9.028h1.18l4.14,6.852v-6.852h-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.161,119.451h4.271v1.101h-5.449v-9.028h5.318v1.101h-4.14v2.934h3.616v1.113h-3.616v2.78Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M385.904,172.068c.679-.047,1.868-.009,2.502.235.505.194.631.719.28,1.133-.384.454-.819.2-1.315.142-2.236-.257-4.14.442-5.527,2.22-2.161,2.77-1.384,6.799,1.588,8.615,3.689,2.256,8.45-.123,8.922-4.38.047-.423-.073-.955.316-1.235.368-.264,1.044-.111,1.102.377.164,1.36-.52,3.259-1.282,4.373-3.513,5.137-11.453,3.849-13.086-2.175-1.19-4.399,1.932-8.988,6.5-9.306v.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.385,175.066c.674-.138,1.185.548.796,1.142l-5.01,5.747c-.268.347-.629.511-1.05.29l-2.443-2.452c-.352-.563.152-1.239.796-1.108.138.028.361.221.473.32.523.454,1.018,1.03,1.534,1.5l4.585-5.24c.071-.076.219-.178.318-.199h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M404.555,174.133c2.567,0,4.074,1.966,4.074,4.534s-1.507,4.494-4.074,4.494h-3.499v-9.028h3.499ZM404.555,182.06c1.899,0,2.882-1.469,2.882-3.393s-.983-3.431-2.882-3.431h-2.307v6.825h2.307Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.936,178.666c0-2.567,1.99-4.689,4.56-4.689s4.585,2.122,4.585,4.689-2.004,4.651-4.585,4.651-4.56-2.096-4.56-4.651ZM417.887,178.666c0-1.939-1.467-3.59-3.393-3.59-1.901,0-3.366,1.652-3.366,3.59,0,1.925,1.467,3.551,3.366,3.551,1.925,0,3.393-1.624,3.393-3.551Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.292,174.133h1.192v9.028h-1.152l-4.166-6.878v6.878h-1.192v-9.028h1.18l4.14,6.852v-6.852h-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.161,182.06h4.271v1.101h-5.449v-9.028h5.318v1.101h-4.14v2.934h3.616v1.113h-3.616v2.78Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M385.904,203.375c.679-.047,1.868-.009,2.502.235.505.194.631.719.28,1.133-.384.454-.819.2-1.315.142-2.236-.257-4.14.442-5.527,2.22-2.161,2.77-1.384,6.799,1.588,8.615,3.689,2.256,8.45-.123,8.922-4.38.047-.423-.073-.955.316-1.235.368-.264,1.044-.111,1.102.377.164,1.36-.52,3.259-1.282,4.373-3.513,5.137-11.453,3.849-13.086-2.175-1.19-4.399,1.932-8.988,6.5-9.306v.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.385,206.373c.674-.138,1.185.548.796,1.142l-5.01,5.747c-.268.347-.629.511-1.05.29l-2.443-2.452c-.352-.563.152-1.239.796-1.108.138.028.361.221.473.32.523.454,1.018,1.03,1.534,1.5l4.585-5.24c.071-.076.219-.178.318-.199h0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M404.555,205.442c2.567,0,4.074,1.966,4.074,4.534s-1.507,4.494-4.074,4.494h-3.499v-9.028h3.499ZM404.555,213.368c1.899,0,2.882-1.469,2.882-3.393s-.983-3.431-2.882-3.431h-2.307v6.825h2.307Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.936,209.975c0-2.567,1.99-4.689,4.56-4.689s4.585,2.122,4.585,4.689-2.004,4.651-4.585,4.651-4.56-2.096-4.56-4.651ZM417.887,209.975c0-1.939-1.467-3.59-3.393-3.59-1.901,0-3.366,1.652-3.366,3.59,0,1.925,1.467,3.551,3.366,3.551,1.925,0,3.393-1.624,3.393-3.551Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.292,205.442h1.192v9.028h-1.152l-4.166-6.878v6.878h-1.192v-9.028h1.18l4.14,6.852v-6.852h-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.161,213.368h4.271v1.101h-5.449v-9.028h5.318v1.101h-4.14v2.934h3.616v1.113h-3.616v2.78Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M372.932,266.792c-.073-.016-.213-.159-.249-.23-.15-.294-.028-.529.242-.674l9.066-.024c.546.054.546.824.112.923-.105.024-.423-.036-.453.055.059,1.36-.055,2.533-.847,3.666-.634.909-1.327,1.272-2.117,1.947-.223.19-.27.361-.045.584.29.289.802.568,1.137.867.914.812,1.602,1.776,1.806,3.008.098.591.054,1.189.067,1.785l.045.045c.252.016.491-.059.644.192.2.327.017.681-.347.739h-8.912c-.413-.031-.622-.496-.325-.807.228-.238.486-.016.695-.202.003-.841-.045-1.607.213-2.417.33-1.033,1.076-1.878,1.901-2.554.256-.209.708-.467.912-.672.1-.1.15-.235.102-.373-.057-.162-.689-.551-.864-.689-1.177-.931-2.16-2.155-2.258-3.72-.028-.427.05-.938.003-1.348-.005-.043-.003-.078-.047-.104-.138-.021-.351.028-.479,0h0l-.003.002ZM380.973,266.792h-6.845s-.054.047-.059.06c-.036.078-.026,1.08-.016,1.239.102,1.484.949,2.523,2.065,3.405.546.432,1.159.601,1.075,1.439-.052.515-.833.904-1.211,1.209-1.069.867-1.837,1.906-1.93,3.331-.009.142-.016,1.159.016,1.213.028.047.126.062.178.06,2.165-.092,4.425.117,6.579,0,.041-.002.183-.003.195-.052-.007-.705.048-1.363-.13-2.049-.256-.987-.916-1.771-1.681-2.414-.567-.477-1.669-.917-1.254-1.854.162-.365.909-.793,1.246-1.078.971-.817,1.738-1.831,1.819-3.15.019-.325.036-.949,0-1.258-.005-.043-.003-.078-.047-.104h0ZM374.89,268.885c.181.693.738,1.332,1.272,1.793.437.377.942.667,1.349,1.075.427-.394.933-.693,1.37-1.075.541-.473,1.083-1.082,1.272-1.793h-5.263ZM380.002,277.389c-.916-1.431-2.847-1.799-4.224-.786-.468.344-.904.892-1.037,1.46h5.56c-.035-.232-.171-.473-.297-.674h-.002ZM377.228,275.124c-.107.461.539.513.589.171.01-.067,0-.218-.038-.273-.135-.194-.498-.136-.553.102h.002ZM377.399,274.372c.541.168.577-.705.022-.579-.263.06-.273.501-.022.579Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M391.003,268.207c1.913,0,2.687,1.415,2.687,2.816,0,1.429-.772,2.816-2.687,2.816h-2.398v3.393h-1.192v-9.028h3.59v.002ZM390.925,272.729c1.126,0,1.572-.838,1.572-1.704,0-.838-.432-1.716-1.507-1.716h-2.384v3.419h2.319Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.58,276.134h4.271v1.101h-5.449v-9.028h5.32v1.101h-4.14v2.934h3.614v1.113h-3.614v2.778l-.002.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.092,268.207h1.192v9.028h-1.152l-4.166-6.878v6.878h-1.192v-9.028h1.18l4.14,6.852v-6.852h-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.28,268.207c2.567,0,4.074,1.966,4.074,4.534s-1.507,4.494-4.074,4.494h-3.497v-9.028h3.497ZM415.28,276.134c1.901,0,2.882-1.469,2.882-3.393s-.981-3.431-2.882-3.431h-2.305v6.825h2.305Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.289,277.235v-9.028h1.192v9.028h-1.192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.301,268.207h1.192v9.028h-1.152l-4.166-6.878v6.878h-1.192v-9.028h1.178l4.14,6.852v-6.852Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.362,272.741c0-2.567,2.004-4.689,4.572-4.689,1.192,0,2.255.458,3.039,1.178l-.826.772c-.577-.51-1.363-.852-2.213-.852-1.901,0-3.379,1.652-3.379,3.59s1.479,3.551,3.379,3.551c1.624,0,2.961-1.101,2.961-2.542h-2.619v-1.035h3.931c0,3.157-1.704,4.677-4.271,4.677s-4.572-2.096-4.572-4.651h-.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M372.932,141.568c-.073-.016-.213-.159-.249-.23-.15-.294-.028-.529.242-.674l9.066-.024c.546.054.546.824.112.923-.105.024-.423-.036-.453.055.059,1.36-.055,2.533-.847,3.666-.634.909-1.327,1.272-2.117,1.947-.223.19-.27.361-.045.584.29.289.802.568,1.137.867.914.812,1.602,1.776,1.806,3.008.098.591.054,1.189.067,1.785l.045.045c.252.016.491-.059.644.192.2.327.017.681-.347.739h-8.912c-.413-.031-.622-.496-.325-.807.228-.238.486-.016.695-.202.003-.841-.045-1.607.213-2.417.33-1.033,1.076-1.878,1.901-2.554.256-.209.708-.467.912-.672.1-.1.15-.235.102-.373-.057-.162-.689-.551-.864-.689-1.177-.931-2.16-2.155-2.258-3.72-.028-.427.05-.938.003-1.348-.005-.043-.003-.078-.047-.104-.138-.021-.351.028-.479,0h0l-.003.002ZM380.973,141.568h-6.845s-.054.047-.059.06c-.036.078-.026,1.08-.016,1.239.102,1.484.949,2.523,2.065,3.405.546.432,1.159.601,1.075,1.439-.052.515-.833.904-1.211,1.209-1.069.867-1.837,1.906-1.93,3.331-.009.142-.016,1.159.016,1.213.028.047.126.062.178.06,2.165-.092,4.425.117,6.579,0,.041-.002.183-.003.195-.052-.007-.705.048-1.363-.13-2.049-.256-.987-.916-1.771-1.681-2.414-.567-.477-1.669-.917-1.254-1.854.162-.365.909-.793,1.246-1.078.971-.817,1.738-1.831,1.819-3.15.019-.325.036-.949,0-1.258-.005-.043-.003-.078-.047-.104h0ZM374.89,143.66c.181.693.738,1.332,1.272,1.793.437.377.942.667,1.349,1.075.427-.394.933-.693,1.37-1.075.541-.473,1.083-1.082,1.272-1.793h-5.263ZM380.002,152.163c-.916-1.431-2.847-1.799-4.224-.786-.468.344-.904.892-1.037,1.46h5.56c-.035-.232-.171-.473-.297-.674h-.002ZM377.228,149.898c-.107.461.539.513.589.171.01-.067,0-.218-.038-.273-.135-.194-.498-.136-.553.102h.002ZM377.399,149.146c.541.168.577-.705.022-.579-.263.06-.273.501-.022.579Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M391.003,142.985c1.913,0,2.687,1.415,2.687,2.816,0,1.429-.772,2.816-2.687,2.816h-2.398v3.393h-1.192v-9.028h3.59v.002ZM390.925,147.505c1.126,0,1.572-.838,1.572-1.704,0-.838-.432-1.716-1.507-1.716h-2.384v3.419h2.319Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.58,150.912h4.271v1.101h-5.449v-9.028h5.32v1.101h-4.14v2.934h3.614v1.113h-3.614v2.778l-.002.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.092,142.985h1.192v9.028h-1.152l-4.166-6.878v6.878h-1.192v-9.028h1.18l4.14,6.852v-6.852h-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.28,142.985c2.567,0,4.074,1.966,4.074,4.534s-1.507,4.494-4.074,4.494h-3.497v-9.028h3.497ZM415.28,150.912c1.901,0,2.882-1.469,2.882-3.393s-.981-3.431-2.882-3.431h-2.305v6.825h2.305Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.289,152.011v-9.028h1.192v9.028h-1.192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.301,142.985h1.192v9.028h-1.152l-4.166-6.878v6.878h-1.192v-9.028h1.178l4.14,6.852v-6.852Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.362,147.518c0-2.567,2.004-4.689,4.572-4.689,1.192,0,2.255.458,3.039,1.178l-.826.772c-.577-.51-1.363-.852-2.213-.852-1.901,0-3.379,1.652-3.379,3.59s1.479,3.551,3.379,3.551c1.624,0,2.961-1.101,2.961-2.542h-2.619v-1.035h3.931c0,3.157-1.704,4.677-4.271,4.677s-4.572-2.096-4.572-4.651h-.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.03,233.54l.857.016c6.286.494,9.827,7.536,6.503,12.939-3.328,5.41-11.224,5.294-14.389-.211-3.184-5.539.631-12.549,7.027-12.746l.002.002ZM358.718,246.495c1.614-2.032,2.016-4.841,1.007-7.244-1.356-3.234-4.895-5.016-8.316-4.078-.943.259-1.84.722-2.583,1.355-.005.022.252.294.295.339,1.515,1.581,3.098,3.105,4.641,4.661,1.579,1.595,3.134,3.226,4.741,4.788.04.038.152.214.213.178h0l.002.002ZM350.435,240.137c-.05-.052-.1-.105-.15-.155-.816-.822-1.648-1.628-2.447-2.467-2.016,2.455-2.13,6.006-.302,8.604,1.757,2.5,4.898,3.582,7.837,2.661.845-.264,1.647-.705,2.324-1.272.003-.016-.159-.197-.188-.228-2.326-2.41-4.715-4.763-7.073-7.143h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.347,241.451c.019-.002.038-.009.057,0l1.631,1.647-.005,2.609c-.029.316-.309.625-.625.672-.206.029-.762.029-.973.005-.403-.043-.644-.403-.672-.784-.078-1.118.059-2.329.003-3.456.012-.287.29-.657.584-.693h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.64,243.342c.176-.028.931-.031,1.099.005.278.059.548.375.568.66-.052.541.066,1.203-.003,1.728-.043.33-.339.617-.669.65-.235.024-.904.024-1.109-.05-.238-.086-.411-.314-.465-.558-.064-.285-.064-1.569,0-1.852.062-.273.294-.536.579-.581h0v-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.49,243.563l2.231,2.263c-.081.311-.352.53-.67.558-.266.022-.942.031-1.165-.088-.147-.078-.394-.373-.394-.539v-2.194h-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.426,245.906c-.04.01-.045-.016-.067-.035-.207-.161-.487-.484-.682-.681-.491-.498-.971-1.009-1.469-1.501.04-1.705-.007-3.414.016-5.119,0-.054-.019-.1-.017-.152.014-.361.276-.712.648-.762.226-.031.95-.031,1.149.045.232.088.432.335.467.581l.007,7.388-.047.238h0l-.003-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.765,243.222l-.069-.035-2.184-2.205c-.026-.026-.019-.059-.022-.092-.05-.499-.043-1.144.529-1.317.245-.074,1.064-.067,1.298.035.2.088.449.399.449.62v2.991h0v.002Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M369.852,242.697v-5.949h1.192v5.949c0,1.427.969,2.096,2.096,2.096s2.096-.669,2.096-2.096v-5.949h1.192v5.949c0,2.056-1.507,3.236-3.288,3.236s-3.288-1.18-3.288-3.236Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.425,236.748c1.913,0,2.687,1.415,2.687,2.816,0,1.429-.772,2.816-2.687,2.816h-2.398v3.393h-1.192v-9.028h3.59v.002ZM382.347,241.27c1.126,0,1.572-.838,1.572-1.704,0-.838-.432-1.716-1.507-1.716h-2.384v3.419h2.319Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.32,236.748c2.567,0,4.074,1.966,4.074,4.534s-1.507,4.494-4.074,4.494h-3.497v-9.028h3.497ZM390.32,244.675c1.901,0,2.882-1.469,2.882-3.393s-.981-3.431-2.882-3.431h-2.305v6.825h2.305Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.857,245.776l-.878-2.319h-3.877l-.878,2.319h-1.244l3.433-9.028h1.258l3.431,9.028h-1.246ZM397.496,242.409h3.091l-1.546-4.102-1.545,4.102Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.308,236.748v1.101h-2.751v7.925h-1.192v-7.925h-2.751v-1.101h6.695-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.004,244.675h4.271v1.101h-5.449v-9.028h5.318v1.101h-4.14v2.934h3.616v1.113h-3.616v2.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.828,236.748h1.192v9.028h-1.152l-4.166-6.878v6.878h-1.192v-9.028h1.18l4.14,6.852v-6.852h-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.697,244.675h4.271v1.101h-5.449v-9.028h5.318v1.101h-4.14v2.934h3.616v1.113h-3.616v2.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.069,244.675h4.271v1.101h-5.449v-9.028h5.318v1.101h-4.14v2.934h3.616v1.113h-3.616v2.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.76,236.748c2.567,0,4.074,1.966,4.074,4.534s-1.507,4.494-4.074,4.494h-3.499v-9.028h3.499ZM448.76,244.675c1.901,0,2.882-1.469,2.882-3.393s-.981-3.431-2.882-3.431h-2.307v6.825h2.307Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.948,244.675h4.271v1.101h-5.449v-9.028h5.318v1.101h-4.14v2.934h3.616v1.113h-3.616v2.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.639,236.748c2.567,0,4.074,1.966,4.074,4.534s-1.507,4.494-4.074,4.494h-3.499v-9.028h3.499ZM465.639,244.675c1.901,0,2.882-1.469,2.882-3.393s-.981-3.431-2.882-3.431h-2.307v6.825h2.307Z",
    style: {
      fill: "#fff"
    }
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M394.246,77.138c-.587-.784-1.28-.859-1.641-.859-1.056,0-1.387.663-1.387,1.175,0,.24.074.466.316.679.242.225.574.346,1.206.572.783.271,1.522.543,2.034,1.009.453.406.859,1.085.859,2.11,0,1.958-1.417,3.3-3.495,3.3-1.854,0-2.939-1.13-3.466-1.899l1.28-1.222c.482.978,1.401,1.341,2.11,1.341.89,0,1.553-.543,1.553-1.386,0-.361-.121-.648-.392-.905-.377-.346-.978-.543-1.552-.738-.527-.18-1.159-.422-1.672-.874-.332-.287-.798-.843-.798-1.868,0-1.477.995-2.954,3.224-2.954.632,0,1.823.121,2.849,1.175l-1.025,1.342-.002.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.916,79.941v4.957h-1.838v-4.957h-.722v-1.567h.722v-2.231h1.838v2.231h1.266v1.567h-1.266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.15,78.374h1.838v6.524h-1.838v-.843c-.663.949-1.536,1.054-2.004,1.054-2.004,0-3.331-1.567-3.331-3.48,0-1.928,1.311-3.468,3.24-3.468.498,0,1.477.092,2.094,1.056v-.843h.002ZM402.714,81.629c0,1.04.752,1.852,1.807,1.852s1.809-.814,1.809-1.852-.753-1.84-1.809-1.84-1.807.798-1.807,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.574,79.941v4.957h-1.838v-4.957h-.724v-1.567h.724v-2.231h1.838v2.231h1.266v1.567h-1.266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.642,78.374v3.692c0,.346.031.814.392,1.144.226.195.587.332.935.332s.708-.135.935-.332c.361-.332.392-.798.392-1.144v-3.692h1.838v3.993c0,.587-.074,1.37-.798,2.004-.603.527-1.567.738-2.365.738s-1.762-.211-2.365-.738c-.724-.632-.798-1.415-.798-2.004v-3.993h1.838-.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.437,79.925c-.437-.406-.874-.437-1.071-.437-.437,0-.708.213-.708.527,0,.166.076.422.587.587l.437.135c.513.166,1.28.422,1.657.935.195.271.332.663.332,1.085,0,.587-.195,1.175-.724,1.657-.527.484-1.161.693-1.959.693-1.356,0-2.125-.648-2.531-1.083l.964-1.116c.361.422.904.753,1.446.753.513,0,.905-.257.905-.708,0-.408-.332-.574-.574-.663l-.422-.152c-.467-.166-1.009-.377-1.401-.783-.301-.318-.498-.724-.498-1.251,0-.632.301-1.161.677-1.477.513-.406,1.175-.466,1.702-.466.484,0,1.251.06,2.08.693l-.904,1.069.003.003Z"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 479.162,
    y: 103.452,
    width: 135.987,
    height: 26.668,
    style: {
      fill: "#ec2027"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.162,
    y: 134.759,
    width: 135.987,
    height: 26.668,
    style: {
      fill: "#f60"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.162,
    y: 166.066,
    width: 135.987,
    height: 26.668,
    style: {
      fill: "#f60"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.162,
    y: 197.371,
    width: 135.987,
    height: 26.668,
    style: {
      fill: "#00a968"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.162,
    y: 228.678,
    width: 135.987,
    height: 26.668,
    style: {
      fill: "#284049"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.162,
    y: 259.985,
    width: 135.987,
    height: 26.668,
    style: {
      fill: "#7b68ee"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M507.115,205.613v10.726c0,.46.377.836.836.836h1.458v-12.398h-1.458c-.46,0-.836.377-.836.836h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.04,204.776h-1.458v12.398h1.458c.46,0,.836-.377.836-.836v-10.726c0-.46-.377-.836-.836-.836h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.439,203.069c0-.46-.377-.836-.836-.836h-4.216c-.46,0-.836.377-.836.836v1.705h-1.469v12.398h8.827v-12.398h-1.469v-1.705h-.002ZM513.318,203.069c0-.036.033-.069.069-.069h4.216c.036,0,.069.033.069.069v1.705h-4.356v-1.705h.002ZM518.517,211.616h-2.379v2.379h-1.284v-2.379h-2.379v-1.284h2.379v-2.379h1.284v2.379h2.379v1.284Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M536.551,207.715h-4.06v2.934h3.222v1.113h-3.222v3.879h-1.192v-9.028h5.252v1.102Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.263,215.64v-9.028h1.192v9.028h-1.192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.686,215.64l-2.372-3.407h-1.165v3.407h-1.192v-9.028h3.393c1.964,0,2.725,1.415,2.725,2.816,0,1.31-.746,2.699-2.358,2.816l2.398,3.393h-1.427l-.002.002ZM543.149,207.715v3.431h1.885c1.323,0,1.847-.695,1.847-1.717,0-1.009-.589-1.716-1.507-1.716h-2.227l.002.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.459,213.085h1.178c.04.8.8,1.612,2.006,1.612,1.165,0,1.821-.758,1.821-1.558,0-.876-.798-1.27-1.558-1.467l-1.165-.289c-1.913-.46-2.213-1.586-2.213-2.319,0-1.558,1.401-2.605,2.973-2.605,1.584,0,2.856,1.007,2.856,2.619h-1.178c0-.904-.746-1.519-1.716-1.519-.904,0-1.742.603-1.742,1.493,0,.314.104.943,1.31,1.258l1.178.314c1.534.406,2.45,1.192,2.45,2.478,0,1.401-1.14,2.699-3.013,2.699-1.901,0-3.17-1.31-3.183-2.713l-.005-.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.015,206.613v1.101h-2.751v7.925h-1.192v-7.925h-2.751v-1.101h6.695-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.73,215.64l-.878-2.319h-3.877l-.878,2.319h-1.244l3.433-9.028h1.258l3.431,9.028h-1.246ZM568.367,212.273h3.091l-1.546-4.102-1.545,4.102Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.254,215.64v-9.028h1.192v9.028h-1.192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.445,206.613c2.567,0,4.074,1.966,4.074,4.534s-1.507,4.494-4.074,4.494h-3.497v-9.028h3.497ZM582.445,214.54c1.901,0,2.882-1.469,2.882-3.393s-.981-3.431-2.882-3.431h-2.305v6.825h2.305Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M513.363,244.242c.029.048.297.045.347.271.036.161.04,1.014.003,1.175-.1.442-1.076.202-1.415.263-.029-1.686-1.892-2.681-3.305-1.721-.245.168-.387.454-.667.482h-7.452c-.244-.031-.23-.171-.363-.282-1.462-1.222-3.471-.365-3.566,1.52-.403-.074-1.358.228-1.425-.344-.024-.209-.029-.855.003-1.056.045-.27.323-.254.358-.309.022-.036.033-.695.074-.869.333-1.403,1.605-.819,2.251-1.655.924-1.197,1.429-3.428,3.176-3.582h11.127c.539.045.802.434.848.943l.009,5.164h0l-.004-.002ZM499.288,241.676h3.654l.069-.069v-2.574l-.069-.069h-1.47c-.263,0-.729.273-.897.482-.237.297-1.107,1.719-1.251,2.059-.024.059-.048.104-.036.171h0ZM507.967,238.976c-2.438.266-2.225,4.045.401,3.848,2.483-.185,2.17-4.129-.401-3.848Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.878,247.037c-1.391-1.472.836-3.651,2.284-2.215,1.517,1.505-.824,3.761-2.284,2.215ZM498.908,245.318c-.793.161-.57,1.446.301,1.266.76-.155.567-1.443-.301-1.266Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.362,247.037c-1.46,1.545-3.801-.71-2.284-2.215,1.448-1.436,3.675.743,2.284,2.215ZM510.08,245.318c-.988.157-.427,1.755.468,1.158.582-.389.2-1.265-.468-1.158Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "508.207 245.214 508.072 245.931 501.242 245.95 501.134 245.876 501.035 245.214 508.207 245.214",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.345,237.721c-.038-.012-.066-.071-.069-.114-.014-.135.135-.809.278-.874.138-.062.879-.055.987.069.097.112.232.917.093.917h-1.287l-.002.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.757,236.446c.199.194.055.553-.223.517-.062-.009-.53-.268-.593-.32-.249-.206-.145-.56.159-.53.055.005.622.299.658.333h-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.838,236.12c.266-.057.482.185.328.423-.062.098-.587.396-.708.399-.249.01-.382-.221-.245-.435.038-.059.558-.373.625-.389h0v.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.792,236.056c-.083-.083-.117-.916.019-1.004.591-.384.603.964.306,1.054-.081.024-.266.01-.325-.048v-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "508.62 240.48 509.494 240.48 509.494 241.308 508.689 241.308 508.62 241.377 508.62 242.227 507.747 242.227 507.747 241.377 507.678 241.308 506.828 241.308 506.828 240.55 506.896 240.48 507.678 240.48 507.747 240.411 507.747 239.629 507.817 239.56 508.551 239.56 508.62 239.629 508.62 240.48",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M530.727,247.205h-1.166l-.838-6.878-2.87,5.897h-1.035l-2.896-5.897-.824,6.878h-1.166l1.101-9.028h1.075l3.222,6.695,3.21-6.695h1.075l1.113,9.028h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.892,246.106h4.271v1.101h-5.449v-9.028h5.32v1.101h-4.14v2.934h3.614v1.113h-3.614v2.778l-.002.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.581,238.179c2.567,0,4.074,1.966,4.074,4.534s-1.507,4.494-4.074,4.494h-3.499v-9.028h3.499ZM543.581,246.106c1.899,0,2.882-1.469,2.882-3.393s-.983-3.431-2.882-3.431h-2.307v6.825h2.307Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.59,247.205v-9.028h1.192v9.028h-1.192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.654,242.713c0-2.555,2.03-4.689,4.585-4.689,1.389,0,2.593.587,3.393,1.533l-.864.733c-.603-.707-1.52-1.165-2.529-1.165-1.899,0-3.393,1.652-3.393,3.59,0,1.925,1.493,3.551,3.393,3.551,1.009,0,1.926-.458,2.529-1.165l.864.733c-.798.943-2.004,1.534-3.393,1.534-2.554,0-4.585-2.096-4.585-4.651v-.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.965,247.205l-.878-2.319h-3.877l-.878,2.319h-1.246l3.433-9.028h1.258l3.433,9.028h-1.246ZM563.601,243.839h3.093l-1.546-4.102-1.546,4.102h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.681,246.106h3.696v1.101h-4.888v-9.028h1.192v7.927h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.43,247.205l-.878-2.319h-3.879l-.876,2.319h-1.246l3.431-9.028h1.258l3.433,9.028h-1.246.002ZM584.068,243.839h3.093l-1.546-4.102-1.546,4.102h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.956,247.205v-9.028h1.192v9.028h-1.192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.145,238.179c2.567,0,4.074,1.966,4.074,4.534s-1.507,4.494-4.074,4.494h-3.499v-9.028h3.499ZM598.145,246.106c1.899,0,2.882-1.469,2.882-3.393s-.983-3.431-2.882-3.431h-2.307v6.825h2.307Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M520.809,146.921l1.939.384c.34.185.266.434-.003.644-.435.34-1.132.752-1.615,1.049-.209.128-.594.422-.826.428-.397.012-1.107-.302-1.539-.321-.047-.002-.092-.007-.135.016l-6.127,3.689c-.524.107-.8-.511-.394-.838l5.734-3.996c.054-.04.076-.083.098-.143.166-.439.145-1.353.446-1.695.644-.428,1.28-.888,1.942-1.289.131-.079.366-.259.501-.268.335-.026.359.188.337.461-.021.257-.439,1.802-.358,1.882h0v-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M509.624,146.442c-.679,0-1.234.553-1.234,1.234s.553,1.234,1.234,1.234,1.234-.553,1.234-1.234-.553-1.234-1.234-1.234Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.446,151.99c-1.323,1.781-3.437,2.942-5.823,2.942-4.002,0-7.258-3.255-7.258-7.258s3.255-7.258,7.258-7.258,7.239,3.24,7.257,7.229l.328-.228c.022-.107.043-.251.062-.375.052-.34.114-.71.254-1.037-.771-3.654-4.02-6.407-7.901-6.407-4.454,0-8.077,3.623-8.077,8.077s3.623,8.076,8.076,8.076c3.229,0,6.014-1.909,7.305-4.655l-1.482.893h.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.624,144.161c-1.937,0-3.514,1.577-3.514,3.514s1.577,3.514,3.514,3.514,3.514-1.577,3.514-3.514-1.577-3.514-3.514-3.514ZM509.624,150.371c-1.486,0-2.695-1.209-2.695-2.695s1.209-2.695,2.695-2.695,2.695,1.209,2.695,2.695-1.209,2.695-2.695,2.695Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.624,141.881c-3.195,0-5.795,2.6-5.795,5.795s2.6,5.795,5.795,5.795c.624,0,1.223-.102,1.785-.285-.1-.117-.187-.249-.242-.403-.041-.117-.059-.237-.066-.356-.466.145-.964.225-1.477.225-2.744,0-4.976-2.232-4.976-4.978s2.232-4.976,4.976-4.976,4.978,2.232,4.978,4.976c0,.634-.124,1.239-.342,1.799l1.059-.738c.064-.344.102-.698.102-1.061,0-3.195-2.6-5.795-5.795-5.795h0l-.002.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M532.506,144.028h1.192v9.028h-1.152l-4.166-6.878v6.878h-1.192v-9.028h1.178l4.14,6.852v-6.852Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.375,151.955h4.271v1.101h-5.449v-9.028h5.318v1.101h-4.14v2.934h3.616v1.113h-3.616v2.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.229,153.056l-.878-2.319h-3.877l-.878,2.319h-1.246l3.433-9.028h1.258l3.433,9.028h-1.246ZM544.867,149.689h3.093l-1.546-4.102-1.546,4.102h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.482,153.056l-2.372-3.407h-1.165v3.407h-1.192v-9.028h3.393c1.964,0,2.725,1.415,2.725,2.816,0,1.31-.746,2.699-2.358,2.816l2.398,3.393h-1.427l-.002.002ZM552.946,145.131v3.431h1.885c1.323,0,1.847-.695,1.847-1.717,0-1.009-.589-1.716-1.507-1.716h-2.227l.002.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.44,153.056h-1.165l-.838-6.878-2.87,5.897h-1.035l-2.896-5.897-.824,6.878h-1.166l1.101-9.028h1.075l3.222,6.695,3.21-6.695h1.075l1.113,9.028h-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.427,153.056v-9.028h1.192v9.028h-1.192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.53,150.501h1.18c.038.8.798,1.612,2.004,1.612,1.166,0,1.821-.758,1.821-1.558,0-.876-.798-1.27-1.558-1.467l-1.165-.289c-1.913-.46-2.213-1.586-2.213-2.319,0-1.558,1.401-2.605,2.975-2.605,1.584,0,2.854,1.009,2.854,2.619h-1.178c0-.904-.748-1.519-1.717-1.519-.904,0-1.742.603-1.742,1.493,0,.314.105.943,1.31,1.258l1.178.314c1.534.406,2.45,1.192,2.45,2.478,0,1.401-1.14,2.699-3.013,2.699-1.901,0-3.17-1.31-3.183-2.713l-.003-.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.98,150.501h1.18c.038.8.798,1.612,2.004,1.612,1.166,0,1.821-.758,1.821-1.558,0-.876-.798-1.27-1.558-1.467l-1.165-.289c-1.913-.46-2.213-1.586-2.213-2.319,0-1.558,1.401-2.605,2.975-2.605,1.584,0,2.854,1.009,2.854,2.619h-1.178c0-.904-.748-1.519-1.717-1.519-.904,0-1.742.603-1.742,1.493,0,.314.105.943,1.31,1.258l1.178.314c1.534.406,2.45,1.192,2.45,2.478,0,1.401-1.14,2.699-3.013,2.699-1.901,0-3.17-1.31-3.183-2.713l-.003-.003Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M520.809,178.226l1.939.384c.34.185.266.434-.003.644-.435.34-1.132.752-1.615,1.049-.209.128-.594.422-.826.428-.397.012-1.107-.302-1.539-.321-.047-.002-.092-.007-.135.016l-6.127,3.689c-.524.107-.8-.511-.394-.838l5.734-3.996c.054-.04.076-.083.098-.143.166-.439.145-1.353.446-1.695.644-.428,1.28-.888,1.942-1.289.131-.079.366-.259.501-.268.335-.026.359.188.337.461-.021.257-.439,1.802-.358,1.882h0v-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M509.624,177.749c-.679,0-1.234.553-1.234,1.234s.553,1.234,1.234,1.234,1.234-.553,1.234-1.234-.553-1.234-1.234-1.234Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.446,183.295c-1.323,1.781-3.437,2.942-5.823,2.942-4.002,0-7.258-3.255-7.258-7.258s3.255-7.258,7.258-7.258,7.239,3.24,7.257,7.229l.328-.228c.022-.107.043-.251.062-.375.052-.34.114-.71.254-1.037-.771-3.654-4.02-6.407-7.901-6.407-4.454,0-8.077,3.623-8.077,8.077s3.623,8.076,8.076,8.076c3.229,0,6.014-1.909,7.305-4.655l-1.482.893h.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.624,175.467c-1.937,0-3.514,1.577-3.514,3.514s1.577,3.514,3.514,3.514,3.514-1.577,3.514-3.514-1.577-3.514-3.514-3.514ZM509.624,181.676c-1.486,0-2.695-1.209-2.695-2.695s1.209-2.695,2.695-2.695,2.695,1.209,2.695,2.695-1.209,2.695-2.695,2.695Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.624,173.186c-3.195,0-5.795,2.6-5.795,5.795s2.6,5.795,5.795,5.795c.624,0,1.223-.102,1.785-.285-.1-.117-.187-.249-.242-.403-.041-.117-.059-.237-.066-.356-.466.145-.964.225-1.477.225-2.744,0-4.976-2.232-4.976-4.978s2.232-4.976,4.976-4.976,4.978,2.232,4.978,4.976c0,.634-.124,1.239-.342,1.799l1.059-.738c.064-.344.102-.698.102-1.061,0-3.195-2.6-5.795-5.795-5.795h0l-.002.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M532.506,175.328h1.192v9.028h-1.152l-4.166-6.878v6.878h-1.192v-9.028h1.178l4.14,6.852v-6.852Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.375,183.255h4.271v1.101h-5.449v-9.028h5.318v1.101h-4.14v2.934h3.616v1.113h-3.616v2.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.229,184.354l-.878-2.319h-3.877l-.878,2.319h-1.246l3.433-9.028h1.258l3.433,9.028h-1.246ZM544.867,180.989h3.093l-1.546-4.102-1.546,4.102h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.482,184.354l-2.372-3.407h-1.165v3.407h-1.192v-9.028h3.393c1.964,0,2.725,1.415,2.725,2.816,0,1.31-.746,2.699-2.358,2.816l2.398,3.393h-1.427l-.002.002ZM552.946,176.429v3.431h1.885c1.323,0,1.847-.695,1.847-1.717,0-1.009-.589-1.716-1.507-1.716h-2.227l.002.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.44,184.354h-1.165l-.838-6.878-2.87,5.897h-1.035l-2.896-5.897-.824,6.878h-1.166l1.101-9.028h1.075l3.222,6.695,3.21-6.695h1.075l1.113,9.028h-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.427,184.354v-9.028h1.192v9.028h-1.192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.53,181.799h1.18c.038.8.798,1.612,2.004,1.612,1.166,0,1.821-.758,1.821-1.558,0-.876-.798-1.27-1.558-1.467l-1.165-.289c-1.913-.46-2.213-1.586-2.213-2.319,0-1.558,1.401-2.605,2.975-2.605,1.584,0,2.854,1.009,2.854,2.619h-1.178c0-.904-.748-1.519-1.717-1.519-.904,0-1.742.603-1.742,1.493,0,.314.105.943,1.31,1.258l1.178.314c1.534.406,2.45,1.192,2.45,2.478,0,1.401-1.14,2.699-3.013,2.699-1.901,0-3.17-1.31-3.183-2.713l-.003-.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.98,181.799h1.18c.038.8.798,1.612,2.004,1.612,1.166,0,1.821-.758,1.821-1.558,0-.876-.798-1.27-1.558-1.467l-1.165-.289c-1.913-.46-2.213-1.586-2.213-2.319,0-1.558,1.401-2.605,2.975-2.605,1.584,0,2.854,1.009,2.854,2.619h-1.178c0-.904-.748-1.519-1.717-1.519-.904,0-1.742.603-1.742,1.493,0,.314.105.943,1.31,1.258l1.178.314c1.534.406,2.45,1.192,2.45,2.478,0,1.401-1.14,2.699-3.013,2.699-1.901,0-3.17-1.31-3.183-2.713l-.003-.003Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M494.318,115.332v-.681c0-.719-.758-1.807-1.303-2.25-.038-.031-.238-.195-.268-.166.439,1.59-.456,3.079-.798,4.591-.812,3.587.13,7.158,3.919,8.333.219.069.492.147.72.147-1.348-1.149-1.914-3.151-1.37-4.839.06-.035.067-.301.152-.261.035.016.154.487.197.589.124.302.39.677.651.878.041.031.052.079.124.062.035-.038-.076-.84-.081-.971-.069-1.781.629-3.632,2.187-4.585l.085.045c-.104.705-.064,1.427.228,2.084.327.731,1.009,1.284,1.415,1.971.708,1.197.653,2.842.041,4.072l-.734,1.019c2.388-.503,4.485-2.358,5.109-4.741.565-2.155.256-4.706-.848-6.643-.214-.377-.496-.71-.71-1.087-.073,0-.045.181-.043.228.071,1.049.173,1.774-.152,2.818-.064.207-.32.84-.463.973-.045.041-.069.029-.126.028-.067-.95-.232-1.901-.646-2.763-.581-1.209-1.622-2.151-2.355-3.262-.767-1.163-1.441-2.637-.8-4.01-1.12.359-2.084,1.382-2.498,2.478-.529,1.401-.206,2.878-.662,4.335-.178.568-.482,1.263-.971,1.61h0v-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M509.335,118.636c0-2.555,2.03-4.689,4.585-4.689,1.389,0,2.593.589,3.393,1.533l-.864.734c-.603-.708-1.519-1.166-2.528-1.166-1.901,0-3.393,1.652-3.393,3.59,0,1.925,1.493,3.551,3.393,3.551,1.009,0,1.925-.458,2.528-1.165l.864.733c-.8.943-2.004,1.534-3.393,1.534-2.555,0-4.585-2.096-4.585-4.651v-.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.647,123.128l-.878-2.319h-3.877l-.878,2.319h-1.244l3.433-9.028h1.258l3.431,9.028h-1.246ZM520.284,119.762h3.091l-1.546-4.102-1.545,4.102Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.098,114.102v1.101h-2.751v7.925h-1.192v-7.925h-2.751v-1.101h6.695-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.501,123.128l-.878-2.319h-3.879l-.876,2.319h-1.246l3.431-9.028h1.258l3.433,9.028h-1.244ZM534.139,119.762h3.091l-1.545-4.102-1.546,4.102Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.305,120.572h1.178c.04.8.8,1.612,2.006,1.612,1.165,0,1.821-.758,1.821-1.558,0-.876-.798-1.27-1.558-1.467l-1.165-.289c-1.913-.46-2.213-1.586-2.213-2.319,0-1.558,1.401-2.605,2.973-2.605,1.584,0,2.856,1.007,2.856,2.619h-1.178c0-.904-.746-1.519-1.716-1.519-.904,0-1.742.603-1.742,1.493,0,.314.104.943,1.31,1.258l1.178.314c1.534.406,2.45,1.192,2.45,2.478,0,1.401-1.14,2.699-3.013,2.699-1.901,0-3.17-1.31-3.183-2.713l-.005-.003Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.861,114.102v1.101h-2.751v7.925h-1.192v-7.925h-2.751v-1.101h6.695-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.105,123.128l-2.372-3.407h-1.165v3.407h-1.192v-9.028h3.393c1.964,0,2.725,1.415,2.725,2.816,0,1.31-.746,2.699-2.357,2.816l2.398,3.393h-1.429l-.002.002ZM556.569,115.203v3.431h1.887c1.323,0,1.847-.695,1.847-1.717,0-1.009-.589-1.716-1.507-1.716h-2.227v.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.839,118.636c0-2.567,1.992-4.689,4.56-4.689,2.581,0,4.585,2.122,4.585,4.689s-2.004,4.651-4.585,4.651c-2.567,0-4.56-2.096-4.56-4.651ZM570.792,118.636c0-1.939-1.467-3.59-3.393-3.59-1.899,0-3.366,1.652-3.366,3.59,0,1.925,1.469,3.551,3.366,3.551,1.926,0,3.393-1.624,3.393-3.551Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.469,114.102c1.913,0,2.687,1.415,2.687,2.816,0,1.429-.772,2.816-2.687,2.816h-2.398v3.393h-1.192v-9.028h3.59v.002ZM577.39,118.622c1.127,0,1.574-.838,1.574-1.704,0-.838-.434-1.716-1.508-1.716h-2.383v3.419h2.317,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.487,114.102h1.192v9.028h-1.192v-3.943h-4.428v3.943h-1.192v-9.028h1.192v3.996h4.428v-3.996Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.176,123.128v-9.028h1.192v9.028h-1.192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.239,118.636c0-2.555,2.03-4.689,4.585-4.689,1.389,0,2.593.589,3.392,1.533l-.864.734c-.603-.708-1.519-1.166-2.528-1.166-1.901,0-3.393,1.652-3.393,3.59,0,1.925,1.493,3.551,3.393,3.551,1.009,0,1.925-.458,2.528-1.165l.864.733c-.798.943-2.004,1.534-3.392,1.534-2.555,0-4.585-2.096-4.585-4.651v-.003Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M516.911,267.503l3.685,3.048c.112-.109.23-.214.356-.308v-2.042l-.43-.34h-1.477l.627-.627c-.774-.653-2.158-1.964-2.732-2.03-.739-.085-.974.131-1.512.543-2.307,2.061-4.933,3.889-7.229,5.947-.249.223-.575.435-.337.805.078.121.719.907.807.976.135.107.321.135.463.029,2.32-1.788,4.477-3.794,6.781-5.596.271-.213.66-.657.997-.404h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.576,272.954c0-.581.157-1.142.435-1.636-.8-.677-1.6-1.356-2.422-2.006-.162-.128-.765-.646-.917-.646-.157,0-.458.27-.594.377-1.806,1.403-3.495,2.968-5.299,4.376l-.028,5.164c-.014.152.162.375.299.404h4.027l-.841-1.729v-.162l2.621-1.655-1.455-2.939,3.727,3.378-2.643,1.653.971,1.427,4.729.029c.245,0,.349-.197.401-.409l-.01-2.275c-1.685-.185-2.999-1.614-2.999-3.347h0v-.003Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M524.377,270.54v-3.236h1.121l-2.555-2.555-2.555,2.555h1.121v3.236c-.822.491-1.377,1.387-1.377,2.414,0,1.553,1.258,2.811,2.811,2.811s2.811-1.258,2.811-2.811c0-1.028-.553-1.925-1.377-2.414h0ZM523.069,274.491v.409h-.313v-.418c-.515-.073-.845-.441-.841-.873h.551c0,.233.188.427.501.427.285,0,.446-.169.446-.377,0-.161-.111-.294-.385-.368l-.354-.102c-.629-.161-.739-.537-.739-.781,0-.446.358-.767.822-.831v-.399h.313v.399c.487.055.817.396.814.864h-.556c.005-.233-.161-.399-.409-.399s-.423.152-.423.354c0,.083.022.244.33.327l.335.086c.465.124.809.377.809.822,0,.487-.39.817-.9.859h.002Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M536.133,269.327c2.567,0,4.074,1.966,4.074,4.534s-1.507,4.494-4.074,4.494h-3.499v-9.028h3.499ZM536.133,277.254c1.899,0,2.882-1.469,2.882-3.393s-.983-3.431-2.882-3.431h-2.307v6.825h2.307Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.669,278.353l-.878-2.319h-3.879l-.876,2.319h-1.246l3.431-9.028h1.258l3.433,9.028h-1.244ZM543.306,274.987h3.091l-1.545-4.102-1.546,4.102Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.477,278.353h-1.165l-.838-6.878-2.87,5.897h-1.035l-2.896-5.897-.824,6.878h-1.166l1.101-9.028h1.075l3.222,6.695,3.21-6.695h1.075l1.113,9.028h-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.122,278.353l-.878-2.319h-3.877l-.878,2.319h-1.244l3.433-9.028h1.258l3.431,9.028h-1.246ZM563.76,274.987h3.091l-1.546-4.102-1.545,4.102Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.874,273.861c0-2.567,2.006-4.689,4.573-4.689,1.192,0,2.253.458,3.037,1.178l-.824.772c-.577-.51-1.363-.852-2.213-.852-1.901,0-3.381,1.652-3.381,3.59s1.481,3.551,3.381,3.551c1.624,0,2.96-1.101,2.96-2.542h-2.621v-1.035h3.931c0,3.157-1.704,4.677-4.271,4.677s-4.573-2.096-4.573-4.651h.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.593,277.254h4.271v1.101h-5.449v-9.028h5.32v1.101h-4.14v2.934h3.614v1.113h-3.614v2.778l-.002.002Z",
    style: {
      fill: "#fff"
    }
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M506.616,74.847v10.05h-1.959v-10.05h1.959Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.634,78.374h1.838v.843c.346-.482.964-1.056,2.018-1.056.574,0,1.417.166,1.928.798.453.558.513,1.206.513,1.84v4.098h-1.838v-3.556c0-.361-.016-.935-.347-1.28-.285-.302-.677-.332-.859-.332-.482,0-.859.166-1.13.572-.271.422-.287.89-.287,1.266v3.329h-1.838v-6.524h.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.592,80.364c-.39-.361-.874-.574-1.507-.574-1.222,0-1.838.89-1.838,1.84,0,1.069.798,1.852,1.899,1.852.406,0,.949-.119,1.446-.572v1.793c-.361.181-.935.406-1.688.406-1.025,0-1.928-.39-2.516-.949-.498-.466-1.04-1.282-1.04-2.502,0-1.146.466-2.065,1.13-2.652.798-.708,1.717-.845,2.35-.845.679,0,1.235.136,1.762.392v1.809h.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.898,74.517c.603,0,1.101.498,1.101,1.101s-.498,1.101-1.101,1.101-1.101-.498-1.101-1.101.498-1.101,1.101-1.101ZM524.816,78.374v6.524h-1.838v-6.524h1.838Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.568,73.914h1.838v10.983h-1.838v-.843c-.663.949-1.536,1.054-2.004,1.054-2.004,0-3.329-1.567-3.329-3.48,0-1.928,1.31-3.468,3.24-3.468.498,0,1.477.092,2.094,1.056v-5.302ZM528.132,81.629c0,1.04.753,1.852,1.807,1.852s1.809-.814,1.809-1.852-.753-1.84-1.809-1.84-1.807.798-1.807,1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.556,83.075c-.195.484-.935,2.034-3.208,2.034-1.056,0-1.854-.301-2.502-.917-.724-.679-1.025-1.522-1.025-2.547,0-1.296.527-2.094.995-2.562.769-.753,1.672-.919,2.455-.919,1.327,0,2.094.527,2.547,1.071.693.829.784,1.852.784,2.562v.15h-4.883c0,.392.105.814.316,1.101.195.271.603.619,1.311.619.693,0,1.22-.332,1.522-.859l1.688.271-.002-.003ZM539.87,80.77c-.15-.89-.874-1.311-1.552-1.311s-1.387.439-1.536,1.311h3.088Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.018,78.374h1.838v.843c.347-.482.964-1.056,2.018-1.056.574,0,1.417.166,1.928.798.453.558.513,1.206.513,1.84v4.098h-1.838v-3.556c0-.361-.016-.935-.347-1.28-.287-.302-.679-.332-.859-.332-.482,0-.859.166-1.13.572-.271.422-.287.89-.287,1.266v3.329h-1.838v-6.524h.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.904,79.941v4.957h-1.838v-4.957h-.722v-1.567h.722v-2.231h1.838v2.231h1.266v1.567h-1.266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.874,74.847v8.362h3.105v1.688h-5.064v-10.05h1.959Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.467,83.075c-.195.484-.935,2.034-3.21,2.034-1.056,0-1.854-.301-2.502-.917-.724-.679-1.025-1.522-1.025-2.547,0-1.296.527-2.094.995-2.562.769-.753,1.672-.919,2.457-.919,1.327,0,2.094.527,2.547,1.071.693.829.783,1.852.783,2.562v.15h-4.883c0,.392.105.814.318,1.101.195.271.603.619,1.31.619.693,0,1.222-.332,1.522-.859l1.688.271v-.003ZM569.779,80.77c-.152-.89-.874-1.311-1.553-1.311s-1.386.439-1.536,1.311h3.089Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.983,78.374l1.719,3.675,1.719-3.675h2.049l-3.284,6.524h-.964l-3.283-6.524h2.049-.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.626,83.075c-.195.484-.935,2.034-3.21,2.034-1.056,0-1.854-.301-2.502-.917-.724-.679-1.025-1.522-1.025-2.547,0-1.296.527-2.094.995-2.562.769-.753,1.672-.919,2.457-.919,1.327,0,2.094.527,2.545,1.071.693.829.784,1.852.784,2.562v.15h-4.883c0,.392.105.814.318,1.101.195.271.603.619,1.31.619.693,0,1.222-.332,1.522-.859l1.688.271v-.003ZM584.938,80.77c-.152-.89-.874-1.311-1.553-1.311s-1.386.439-1.536,1.311h3.089Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.926,73.914v10.983h-1.838v-10.983h1.838Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M852.615,104.622l-.003-.003h-8.979c-.384,0-.696.311-.696.696v22.95c0,.384.311.695.696.695h15.996c.384,0,.695-.311.695-.695v-15.933h-7.706v-7.706l-.002-.003Z",
    style: {
      fill: "#76b6f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "852.615 112.328 860.32 112.328 852.615 104.622 852.615 112.328",
    style: {
      fill: "#8fcef9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "860.322 120.035 860.322 112.328 860.32 112.328 852.615 112.328 852.615 112.328 860.322 120.035",
    style: {
      fill: "#363636"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M848.221,127.24l.047-.486c.104.038.302.041.325.041.235,0,.327-.174.327-.387v-2.654h.532v2.654c0,.484-.235.89-.859.89-.073,0-.24-.019-.371-.057v-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.172,123.753c.598,0,.862.43.862.862s-.264.855-.862.855h-.546v.924h-.532v-2.643h1.078v.002ZM851.144,125.004c.257,0,.354-.2.354-.389,0-.192-.097-.39-.346-.39h-.525v.779h.518-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.293,125.077c0-.752.591-1.368,1.349-1.368.401,0,.75.166.978.422l-.387.333c-.15-.161-.361-.259-.591-.259-.46,0-.815.401-.815.874s.349.886.833.886c.346,0,.688-.207.688-.513h-.75v-.434h1.33c0,.978-.541,1.427-1.258,1.427-.796,0-1.377-.619-1.377-1.367v-.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M852.615,166.009l-.003-.003h-8.979c-.384,0-.696.311-.696.696v22.95c0,.384.311.695.696.695h15.996c.384,0,.695-.311.695-.695v-15.933h-7.706v-7.706l-.002-.003Z",
    style: {
      fill: "#76b6f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "852.615 173.715 860.32 173.715 852.615 166.009 852.615 173.715",
    style: {
      fill: "#8fcef9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "860.322 181.422 860.322 173.716 860.32 173.715 852.615 173.715 852.615 173.715 860.322 181.422",
    style: {
      fill: "#363636"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M848.221,188.629l.047-.486c.104.038.302.041.325.041.235,0,.327-.174.327-.387v-2.654h.532v2.654c0,.484-.235.89-.859.89-.073,0-.24-.019-.371-.057v-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.172,185.142c.598,0,.862.43.862.864s-.264.854-.862.854h-.546v.924h-.532v-2.643h1.078v.002ZM851.144,186.393c.257,0,.354-.2.354-.387,0-.194-.097-.392-.346-.392h-.525v.779h.518-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.293,186.466c0-.752.591-1.368,1.349-1.368.401,0,.75.166.978.422l-.387.333c-.15-.161-.361-.259-.591-.259-.46,0-.815.401-.815.874s.349.886.833.886c.346,0,.688-.207.688-.513h-.75v-.434h1.33c0,.978-.541,1.427-1.258,1.427-.796,0-1.377-.619-1.377-1.367v-.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M852.615,196.703l-.003-.003h-8.979c-.384,0-.696.311-.696.696v22.95c0,.384.311.695.696.695h15.996c.384,0,.695-.311.695-.695v-15.933h-7.706v-7.706l-.002-.003Z",
    style: {
      fill: "#ff2116"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "852.615 204.408 860.32 204.408 852.615 196.703 852.615 204.408",
    style: {
      fill: "#f46460"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M849.966,215.834c.598,0,.862.43.862.862s-.264.855-.862.855h-.546v.924h-.534v-2.643h1.08v.002ZM849.94,217.085c.257,0,.352-.2.352-.389,0-.192-.095-.39-.344-.39h-.525v.779h.518-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.286,215.834c.758,0,1.201.575,1.201,1.329,0,.748-.442,1.315-1.201,1.315h-1.037v-2.643h1.037ZM852.286,218.006c.441,0,.667-.39.667-.843s-.226-.855-.667-.855h-.504v1.698h.504Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.607,216.306h-1.101v.636h.874v.468h-.874v1.066h-.534v-2.643h1.634v.473Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M852.615,258.09l-.003-.003h-8.979c-.384,0-.696.311-.696.696v22.95c0,.384.311.695.696.695h15.996c.384,0,.695-.311.695-.695v-15.933h-7.706v-7.706l-.002-.003Z",
    style: {
      fill: "#736357"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "852.615 265.795 860.32 265.795 852.615 258.09 852.615 265.795",
    style: {
      fill: "#8e827b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "860.322 273.503 860.322 265.797 860.32 265.795 852.615 265.795 852.615 265.795 860.322 273.503",
    style: {
      fill: "#363636"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M848.727,278.546c0-.752.591-1.368,1.349-1.368.401,0,.75.166.978.422l-.387.333c-.15-.161-.361-.259-.591-.259-.46,0-.815.401-.815.874s.349.886.833.886c.346,0,.688-.207.688-.513h-.75v-.434h1.33c0,.978-.541,1.427-1.258,1.427-.796,0-1.377-.619-1.377-1.367v-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.789,279.866v-2.643h.534v2.643h-.534Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.596,277.695h-1.101v.638h.874v.467h-.874v1.066h-.534v-2.643h1.634v.473Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M842.908,135.315l-.003-.003h-8.979c-.384,0-.696.311-.696.696v22.95c0,.384.311.695.696.695h15.996c.384,0,.695-.311.695-.695v-15.933h-7.706v-7.706l-.002-.003Z",
    style: {
      fill: "#76b6f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "842.908 143.021 850.616 143.021 842.908 135.315 842.908 143.021",
    style: {
      fill: "#8fcef9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "850.616 150.729 850.616 143.023 850.616 143.021 842.908 143.021 842.908 143.021 850.616 150.729",
    style: {
      fill: "#363636"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M838.516,157.935l.047-.486c.104.038.302.041.327.041.233,0,.325-.174.325-.387v-2.654h.534v2.654c0,.484-.235.89-.859.89-.073,0-.242-.019-.373-.057v-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.467,154.448c.598,0,.862.43.862.864s-.264.854-.862.854h-.546v.924h-.534v-2.643h1.08v.002ZM841.439,155.699c.257,0,.352-.2.352-.387,0-.194-.095-.392-.344-.392h-.525v.779h.518-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.59,155.772c0-.752.589-1.368,1.349-1.368.399,0,.748.166.978.422l-.387.333c-.149-.161-.361-.259-.589-.259-.461,0-.817.401-.817.874s.349.886.833.886c.346,0,.688-.207.688-.513h-.748v-.434h1.33c0,.978-.541,1.427-1.258,1.427-.798,0-1.377-.619-1.377-1.367l-.002-.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M862.319,135.319l-.003-.003h-8.977c-.384,0-.696.311-.696.696v22.946c0,.384.311.695.696.695h15.992c.384,0,.695-.311.695-.695v-15.932h-7.706v-7.708Z",
    style: {
      fill: "#93278f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "862.319 143.025 870.025 143.025 862.319 135.319 862.319 143.025",
    style: {
      fill: "#c957c9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "870.027 150.73 870.027 143.025 870.025 143.025 862.319 143.025 862.319 143.025 870.027 150.73",
    style: {
      fill: "#363636"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M858.8,154.447c.598,0,.862.43.862.862s-.264.855-.862.855h-.546v.924h-.534v-2.643h1.08v.002ZM858.774,155.698c.257,0,.352-.2.352-.389,0-.192-.095-.39-.344-.39h-.525v.779h.518-.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.521,154.447h.534v2.643h-.48l-.959-1.657v1.657h-.532v-2.643h.494l.943,1.638v-1.638h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.532,155.77c0-.752.589-1.368,1.349-1.368.399,0,.748.166.978.422l-.387.333c-.149-.161-.361-.259-.589-.259-.461,0-.817.401-.817.874s.349.886.833.886c.346,0,.688-.207.688-.513h-.748v-.434h1.33c0,.978-.541,1.427-1.258,1.427-.798,0-1.377-.619-1.377-1.367l-.002-.002Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "860.322 212.116 860.322 204.41 860.32 204.408 852.615 204.408 852.615 204.408 860.322 212.116",
    style: {
      fill: "#363636"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 934.405,
    y: 106.709,
    width: 62.172,
    height: 19.137,
    rx: 0.775,
    ry: 0.775,
    style: {
      fill: "#1677ff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M942.848,118.99l1.035-6.557,2.384,5.244,2.431-5.254.969,6.567h-.708l-.587-4.321-2.115,4.582-2.087-4.582-.613,4.321h-.71.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.682,117.072c0-1.173.866-2.04,2.049-2.04s2.049.867,2.049,2.04-.874,2.03-2.049,2.03-2.049-.855-2.049-2.03ZM951.371,117.072c0,.95.67,1.434,1.36,1.434.7,0,1.362-.494,1.362-1.434,0-.95-.653-1.444-1.362-1.444s-1.36.505-1.36,1.444Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.8,115.125h.669v.42c.066-.102.354-.513.876-.513.204,0,.428.074.596.159l-.318.606c-.149-.104-.289-.131-.39-.131-.271,0-.439.112-.541.242-.112.149-.225.409-.225,1.042v2.04h-.669v-3.865h.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.757,118.003c-.112.214-.278.446-.475.624-.354.318-.793.475-1.285.475-.933,0-1.909-.587-1.909-2.021,0-1.156.708-2.049,1.871-2.049.755,0,1.23.373,1.463.71.242.344.38.94.363,1.451h-3.01c.01.802.56,1.313,1.23,1.313.316,0,.567-.093.791-.278.176-.15.318-.344.401-.53l.558.308.002-.002ZM961.095,116.635c-.112-.606-.567-1.007-1.137-1.007s-1.033.428-1.137,1.007h2.274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.14,112.777h1.266c.624,0,1.508.066,2.291.727.568.475,1.061,1.266,1.061,2.384,0,1.304-.643,2.002-1.088,2.384-.568.484-1.165.717-2.274.717h-1.258v-6.213h.002ZM965.827,118.338h.606c.494,0,1.173-.055,1.78-.56.465-.39.838-1.006.838-1.89,0-1.491-1.042-2.46-2.618-2.46h-.606v4.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.28,118.003c-.112.214-.28.446-.475.624-.354.318-.793.475-1.287.475-.931,0-1.909-.587-1.909-2.021,0-1.156.708-2.049,1.873-2.049.753,0,1.228.373,1.462.71.242.344.382.94.363,1.451h-3.008c.009.802.558,1.313,1.228,1.313.318,0,.567-.093.793-.278.176-.15.316-.344.401-.53l.56.308v-.002ZM973.618,116.635c-.112-.606-.568-1.007-1.137-1.007s-1.035.428-1.137,1.007h2.274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.016,115.74v3.25h-.67v-3.25h-.409v-.615h.409v-1.398h.67v1.398h.67v.615h-.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.278,115.125h.67v3.865h-.67v-.541c-.223.289-.643.651-1.323.651-.978,0-1.882-.689-1.882-2.049,0-1.332.895-2.023,1.882-2.023.746,0,1.146.411,1.323.644v-.549.002ZM977.765,117.053c0,.829.465,1.451,1.266,1.451.819,0,1.285-.679,1.285-1.444,0-.997-.689-1.434-1.285-1.434-.662,0-1.266.484-1.266,1.427Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.545,113.186c.261,0,.475.216.475.475,0,.261-.214.475-.475.475s-.475-.214-.475-.475c0-.259.214-.475.475-.475ZM982.88,115.125v3.865h-.669v-3.865h.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.816,112.2v6.79h-.669v-6.79h.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.672,116.02c-.093-.223-.289-.392-.541-.392-.24,0-.465.14-.465.439,0,.278.187.363.625.549.558.233.819.409.969.596.168.204.204.409.204.624,0,.812-.587,1.266-1.332,1.266-.157,0-1.023-.019-1.349-.987l.577-.242c.074.204.299.632.783.632.439,0,.634-.325.634-.615,0-.361-.261-.484-.625-.643-.465-.204-.764-.354-.94-.567-.15-.187-.176-.373-.176-.568,0-.679.475-1.082,1.126-1.082.206,0,.753.038,1.061.7l-.549.289h-.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 934.405,
    y: 138.118,
    width: 62.172,
    height: 19.137,
    rx: 0.775,
    ry: 0.775,
    style: {
      fill: "#1677ff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M942.848,150.399l1.035-6.557,2.384,5.244,2.431-5.254.969,6.567h-.708l-.587-4.321-2.115,4.582-2.087-4.582-.613,4.321h-.71.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.682,148.479c0-1.173.866-2.04,2.049-2.04s2.049.867,2.049,2.04-.874,2.03-2.049,2.03-2.049-.855-2.049-2.03ZM951.371,148.479c0,.95.67,1.434,1.36,1.434.7,0,1.362-.494,1.362-1.434,0-.95-.653-1.444-1.362-1.444s-1.36.505-1.36,1.444Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.8,146.532h.669v.42c.066-.102.354-.513.876-.513.204,0,.428.074.596.159l-.318.606c-.149-.104-.289-.131-.39-.131-.271,0-.439.112-.541.242-.112.149-.225.409-.225,1.042v2.04h-.669v-3.865h.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.757,149.412c-.112.214-.278.446-.475.624-.354.318-.793.475-1.285.475-.933,0-1.909-.587-1.909-2.021,0-1.156.708-2.049,1.871-2.049.755,0,1.23.373,1.463.71.242.344.38.94.363,1.451h-3.01c.01.802.56,1.313,1.23,1.313.316,0,.567-.093.791-.278.176-.15.318-.344.401-.53l.558.308.002-.002ZM961.095,148.042c-.112-.606-.567-1.007-1.137-1.007s-1.033.428-1.137,1.007h2.274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.14,144.184h1.266c.624,0,1.508.066,2.291.727.568.475,1.061,1.266,1.061,2.384,0,1.304-.643,2.002-1.088,2.384-.568.484-1.165.717-2.274.717h-1.258v-6.213h.002ZM965.827,149.746h.606c.494,0,1.173-.055,1.78-.56.465-.39.838-1.006.838-1.89,0-1.491-1.042-2.46-2.618-2.46h-.606v4.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.28,149.412c-.112.214-.28.446-.475.624-.354.318-.793.475-1.287.475-.931,0-1.909-.587-1.909-2.021,0-1.156.708-2.049,1.873-2.049.753,0,1.228.373,1.462.71.242.344.382.94.363,1.451h-3.008c.009.802.558,1.313,1.228,1.313.318,0,.567-.093.793-.278.176-.15.316-.344.401-.53l.56.308v-.002ZM973.618,148.042c-.112-.606-.568-1.007-1.137-1.007s-1.035.428-1.137,1.007h2.274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.016,147.149v3.25h-.67v-3.25h-.409v-.615h.409v-1.398h.67v1.398h.67v.615h-.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.278,146.532h.67v3.865h-.67v-.541c-.223.289-.643.651-1.323.651-.978,0-1.882-.689-1.882-2.049,0-1.332.895-2.023,1.882-2.023.746,0,1.146.411,1.323.644v-.549.002ZM977.765,148.462c0,.829.465,1.451,1.266,1.451.819,0,1.285-.679,1.285-1.444,0-.997-.689-1.434-1.285-1.434-.662,0-1.266.484-1.266,1.427Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.545,144.595c.261,0,.475.216.475.475,0,.261-.214.475-.475.475s-.475-.214-.475-.475c0-.259.214-.475.475-.475ZM982.88,146.532v3.865h-.669v-3.865h.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.816,143.609v6.79h-.669v-6.79h.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.672,147.427c-.093-.223-.289-.392-.541-.392-.24,0-.465.14-.465.439,0,.278.187.363.625.549.558.233.819.409.969.596.168.204.204.409.204.624,0,.812-.587,1.266-1.332,1.266-.157,0-1.023-.019-1.349-.987l.577-.242c.074.204.299.632.783.632.439,0,.634-.325.634-.615,0-.361-.261-.484-.625-.643-.465-.204-.764-.354-.94-.567-.15-.187-.176-.373-.176-.568,0-.679.475-1.082,1.126-1.082.206,0,.753.038,1.061.7l-.549.289h-.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 934.405,
    y: 169.525,
    width: 62.172,
    height: 19.137,
    rx: 0.775,
    ry: 0.775,
    style: {
      fill: "#1677ff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M942.848,181.806l1.035-6.557,2.384,5.244,2.431-5.254.969,6.567h-.708l-.587-4.321-2.115,4.582-2.087-4.582-.613,4.321h-.71.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.682,179.886c0-1.173.866-2.04,2.049-2.04s2.049.867,2.049,2.04-.874,2.03-2.049,2.03-2.049-.855-2.049-2.03ZM951.371,179.886c0,.95.67,1.434,1.36,1.434.7,0,1.362-.494,1.362-1.434,0-.95-.653-1.444-1.362-1.444s-1.36.505-1.36,1.444Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.8,177.941h.669v.42c.066-.102.354-.513.876-.513.204,0,.428.074.596.159l-.318.606c-.149-.104-.289-.131-.39-.131-.271,0-.439.112-.541.242-.112.149-.225.409-.225,1.042v2.04h-.669v-3.865h.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.757,180.819c-.112.214-.278.446-.475.624-.354.318-.793.475-1.285.475-.933,0-1.909-.587-1.909-2.021,0-1.156.708-2.049,1.871-2.049.755,0,1.23.373,1.463.71.242.344.38.94.363,1.451h-3.01c.01.802.56,1.313,1.23,1.313.316,0,.567-.093.791-.278.176-.15.318-.344.401-.53l.558.308.002-.002ZM961.095,179.449c-.112-.606-.567-1.007-1.137-1.007s-1.033.428-1.137,1.007h2.274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.14,175.593h1.266c.624,0,1.508.066,2.291.727.568.475,1.061,1.266,1.061,2.384,0,1.304-.643,2.002-1.088,2.384-.568.484-1.165.717-2.274.717h-1.258v-6.213h.002ZM965.827,181.154h.606c.494,0,1.173-.055,1.78-.56.465-.39.838-1.006.838-1.89,0-1.491-1.042-2.46-2.618-2.46h-.606v4.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.28,180.819c-.112.214-.28.446-.475.624-.354.318-.793.475-1.287.475-.931,0-1.909-.587-1.909-2.021,0-1.156.708-2.049,1.873-2.049.753,0,1.228.373,1.462.71.242.344.382.94.363,1.451h-3.008c.009.802.558,1.313,1.228,1.313.318,0,.567-.093.793-.278.176-.15.316-.344.401-.53l.56.308v-.002ZM973.618,179.449c-.112-.606-.568-1.007-1.137-1.007s-1.035.428-1.137,1.007h2.274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.016,178.556v3.25h-.67v-3.25h-.409v-.615h.409v-1.398h.67v1.398h.67v.615h-.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.278,177.941h.67v3.865h-.67v-.541c-.223.289-.643.651-1.323.651-.978,0-1.882-.689-1.882-2.049,0-1.332.895-2.023,1.882-2.023.746,0,1.146.411,1.323.644v-.549.002ZM977.765,179.869c0,.829.465,1.451,1.266,1.451.819,0,1.285-.679,1.285-1.444,0-.997-.689-1.434-1.285-1.434-.662,0-1.266.484-1.266,1.427Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.545,176.002c.261,0,.475.216.475.475,0,.261-.214.475-.475.475s-.475-.214-.475-.475c0-.259.214-.475.475-.475ZM982.88,177.941v3.865h-.669v-3.865h.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.816,175.016v6.79h-.669v-6.79h.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.672,178.834c-.093-.223-.289-.392-.541-.392-.24,0-.465.14-.465.439,0,.278.187.363.625.549.558.233.819.409.969.596.168.204.204.409.204.624,0,.812-.587,1.266-1.332,1.266-.157,0-1.023-.019-1.349-.987l.577-.242c.074.204.299.632.783.632.439,0,.634-.325.634-.615,0-.361-.261-.484-.625-.643-.465-.204-.764-.354-.94-.567-.15-.187-.176-.373-.176-.568,0-.679.475-1.082,1.126-1.082.206,0,.753.038,1.061.7l-.549.289h-.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 934.405,
    y: 200.934,
    width: 62.172,
    height: 19.137,
    rx: 0.775,
    ry: 0.775,
    style: {
      fill: "#1677ff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M942.848,213.215l1.035-6.557,2.384,5.244,2.431-5.254.969,6.567h-.708l-.587-4.323-2.115,4.584-2.087-4.584-.613,4.323h-.71.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.682,211.297c0-1.173.866-2.04,2.049-2.04s2.049.867,2.049,2.04-.874,2.03-2.049,2.03-2.049-.857-2.049-2.03ZM951.371,211.297c0,.95.67,1.434,1.36,1.434.7,0,1.362-.494,1.362-1.434,0-.95-.653-1.444-1.362-1.444s-1.36.505-1.36,1.444Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.8,209.35h.669v.42c.066-.102.354-.513.876-.513.204,0,.428.074.596.159l-.318.606c-.149-.104-.289-.131-.39-.131-.271,0-.439.112-.541.242-.112.149-.225.409-.225,1.042v2.04h-.669v-3.865h.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.757,212.228c-.112.214-.278.446-.475.624-.354.318-.793.475-1.285.475-.933,0-1.909-.587-1.909-2.021,0-1.156.708-2.049,1.871-2.049.755,0,1.23.373,1.463.71.242.344.38.94.363,1.451h-3.01c.01.802.56,1.313,1.23,1.313.316,0,.567-.093.791-.278.176-.15.318-.344.401-.53l.558.308.002-.002ZM961.095,210.86c-.112-.606-.567-1.007-1.137-1.007s-1.033.428-1.137,1.007h2.274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.14,207.002h1.266c.624,0,1.508.066,2.291.727.568.475,1.061,1.266,1.061,2.384,0,1.304-.643,2.002-1.088,2.384-.568.484-1.165.717-2.274.717h-1.258v-6.213h.002ZM965.827,212.563h.606c.494,0,1.173-.055,1.78-.56.465-.39.838-1.006.838-1.89,0-1.491-1.042-2.46-2.618-2.46h-.606v4.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.28,212.228c-.112.214-.28.446-.475.624-.354.318-.793.475-1.287.475-.931,0-1.909-.587-1.909-2.021,0-1.156.708-2.049,1.873-2.049.753,0,1.228.373,1.462.71.242.344.382.94.363,1.451h-3.008c.009.802.558,1.313,1.228,1.313.318,0,.567-.093.793-.278.176-.15.316-.344.401-.53l.56.308v-.002ZM973.618,210.86c-.112-.606-.568-1.007-1.137-1.007s-1.035.428-1.137,1.007h2.274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.016,209.965v3.25h-.67v-3.25h-.409v-.615h.409v-1.398h.67v1.398h.67v.615h-.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.278,209.35h.67v3.865h-.67v-.541c-.223.289-.643.651-1.323.651-.978,0-1.882-.689-1.882-2.049,0-1.33.895-2.021,1.882-2.021.746,0,1.146.411,1.323.644v-.549ZM977.765,211.276c0,.831.465,1.453,1.266,1.453.819,0,1.285-.679,1.285-1.444,0-.997-.689-1.434-1.285-1.434-.662,0-1.266.484-1.266,1.425Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.545,207.411c.261,0,.475.216.475.475,0,.261-.214.475-.475.475s-.475-.214-.475-.475c0-.259.214-.475.475-.475ZM982.88,209.35v3.865h-.669v-3.865h.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.816,206.425v6.79h-.669v-6.79h.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.672,210.245c-.093-.223-.289-.392-.541-.392-.24,0-.465.14-.465.439,0,.278.187.363.625.549.558.233.819.409.969.596.168.204.204.409.204.624,0,.812-.587,1.266-1.332,1.266-.157,0-1.023-.019-1.349-.987l.577-.242c.074.204.299.632.783.632.439,0,.634-.325.634-.615,0-.361-.261-.484-.625-.643-.465-.204-.764-.354-.94-.567-.15-.187-.176-.373-.176-.568,0-.679.475-1.082,1.126-1.082.206,0,.753.038,1.061.7l-.549.289h-.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 934.405,
    y: 232.343,
    width: 62.172,
    height: 19.137,
    rx: 0.775,
    ry: 0.775,
    style: {
      fill: "#1677ff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M942.848,244.622l1.035-6.557,2.384,5.244,2.431-5.254.969,6.567h-.708l-.587-4.321-2.115,4.582-2.087-4.582-.613,4.321h-.71.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.682,242.702c0-1.173.866-2.04,2.049-2.04s2.049.867,2.049,2.04-.874,2.03-2.049,2.03-2.049-.855-2.049-2.03ZM951.371,242.702c0,.95.67,1.434,1.36,1.434.7,0,1.362-.494,1.362-1.434,0-.95-.653-1.444-1.362-1.444s-1.36.505-1.36,1.444Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.8,240.757h.669v.42c.066-.102.354-.513.876-.513.204,0,.428.074.596.159l-.318.606c-.149-.104-.289-.131-.39-.131-.271,0-.439.112-.541.242-.112.149-.225.409-.225,1.042v2.04h-.669v-3.865h.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.757,243.635c-.112.214-.278.446-.475.624-.354.318-.793.475-1.285.475-.933,0-1.909-.587-1.909-2.021,0-1.156.708-2.049,1.871-2.049.755,0,1.23.373,1.463.71.242.344.38.94.363,1.451h-3.01c.01.802.56,1.313,1.23,1.313.316,0,.567-.093.791-.278.176-.15.318-.344.401-.53l.558.308.002-.002ZM961.095,242.265c-.112-.606-.567-1.007-1.137-1.007s-1.033.428-1.137,1.007h2.274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.14,238.409h1.266c.624,0,1.508.066,2.291.727.568.475,1.061,1.266,1.061,2.384,0,1.304-.643,2.002-1.088,2.384-.568.484-1.165.717-2.274.717h-1.258v-6.213h.002ZM965.827,243.969h.606c.494,0,1.173-.055,1.78-.56.465-.39.838-1.006.838-1.89,0-1.491-1.042-2.46-2.618-2.46h-.606v4.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.28,243.635c-.112.214-.28.446-.475.624-.354.318-.793.475-1.287.475-.931,0-1.909-.587-1.909-2.021,0-1.156.708-2.049,1.873-2.049.753,0,1.228.373,1.462.71.242.344.382.94.363,1.451h-3.008c.009.802.558,1.313,1.228,1.313.318,0,.567-.093.793-.278.176-.15.316-.344.401-.53l.56.308v-.002ZM973.618,242.265c-.112-.606-.568-1.007-1.137-1.007s-1.035.428-1.137,1.007h2.274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.016,241.372v3.25h-.67v-3.25h-.409v-.615h.409v-1.398h.67v1.398h.67v.615h-.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.278,240.757h.67v3.865h-.67v-.541c-.223.289-.643.651-1.323.651-.978,0-1.882-.689-1.882-2.049,0-1.332.895-2.023,1.882-2.023.746,0,1.146.411,1.323.644v-.549.002ZM977.765,242.685c0,.829.465,1.451,1.266,1.451.819,0,1.285-.679,1.285-1.444,0-.997-.689-1.434-1.285-1.434-.662,0-1.266.484-1.266,1.427Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.545,238.818c.261,0,.475.216.475.475,0,.261-.214.475-.475.475s-.475-.214-.475-.475c0-.259.214-.475.475-.475ZM982.88,240.757v3.865h-.669v-3.865h.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.816,237.832v6.79h-.669v-6.79h.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.672,241.65c-.093-.223-.289-.392-.541-.392-.24,0-.465.14-.465.439,0,.278.187.363.625.549.558.233.819.409.969.596.168.204.204.409.204.624,0,.812-.587,1.266-1.332,1.266-.157,0-1.023-.019-1.349-.987l.577-.242c.074.204.299.632.783.632.439,0,.634-.325.634-.615,0-.361-.261-.484-.625-.643-.465-.204-.764-.354-.94-.567-.15-.187-.176-.373-.176-.568,0-.679.475-1.082,1.126-1.082.206,0,.753.038,1.061.7l-.549.289h-.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 934.405,
    y: 263.75,
    width: 62.172,
    height: 19.137,
    rx: 0.775,
    ry: 0.775,
    style: {
      fill: "#1677ff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M942.848,276.031l1.035-6.557,2.384,5.244,2.431-5.254.969,6.567h-.708l-.587-4.323-2.115,4.584-2.087-4.584-.613,4.323h-.71.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.682,274.111c0-1.173.866-2.04,2.049-2.04s2.049.867,2.049,2.04-.874,2.03-2.049,2.03-2.049-.857-2.049-2.03ZM951.371,274.111c0,.95.67,1.434,1.36,1.434.7,0,1.362-.494,1.362-1.434,0-.95-.653-1.444-1.362-1.444s-1.36.505-1.36,1.444Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.8,272.166h.669v.42c.066-.102.354-.513.876-.513.204,0,.428.074.596.159l-.318.606c-.149-.104-.289-.131-.39-.131-.271,0-.439.112-.541.242-.112.149-.225.409-.225,1.042v2.04h-.669v-3.865h.002Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.757,275.044c-.112.214-.278.446-.475.624-.354.318-.793.475-1.285.475-.933,0-1.909-.587-1.909-2.021,0-1.156.708-2.049,1.871-2.049.755,0,1.23.373,1.463.71.242.344.38.94.363,1.451h-3.01c.01.802.56,1.313,1.23,1.313.316,0,.567-.093.791-.278.176-.15.318-.344.401-.53l.558.308.002-.002ZM961.095,273.676c-.112-.606-.567-1.007-1.137-1.007s-1.033.428-1.137,1.007h2.274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.14,269.818h1.266c.624,0,1.508.066,2.291.727.568.475,1.061,1.266,1.061,2.384,0,1.304-.643,2.002-1.088,2.384-.568.484-1.165.717-2.274.717h-1.258v-6.213h.002ZM965.827,275.379h.606c.494,0,1.173-.055,1.78-.56.465-.39.838-1.006.838-1.89,0-1.491-1.042-2.46-2.618-2.46h-.606v4.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.28,275.044c-.112.214-.28.446-.475.624-.354.318-.793.475-1.287.475-.931,0-1.909-.587-1.909-2.021,0-1.156.708-2.049,1.873-2.049.753,0,1.228.373,1.462.71.242.344.382.94.363,1.451h-3.008c.009.802.558,1.313,1.228,1.313.318,0,.567-.093.793-.278.176-.15.316-.344.401-.53l.56.308v-.002ZM973.618,273.676c-.112-.606-.568-1.007-1.137-1.007s-1.035.428-1.137,1.007h2.274Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.016,272.781v3.25h-.67v-3.25h-.409v-.615h.409v-1.398h.67v1.398h.67v.615h-.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.278,272.166h.67v3.865h-.67v-.541c-.223.289-.643.651-1.323.651-.978,0-1.882-.689-1.882-2.049,0-1.33.895-2.021,1.882-2.021.746,0,1.146.411,1.323.644v-.549ZM977.765,274.092c0,.831.465,1.453,1.266,1.453.819,0,1.285-.679,1.285-1.444,0-.997-.689-1.434-1.285-1.434-.662,0-1.266.484-1.266,1.425Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.545,270.227c.261,0,.475.216.475.475,0,.261-.214.475-.475.475s-.475-.214-.475-.475c0-.259.214-.475.475-.475ZM982.88,272.166v3.865h-.669v-3.865h.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.816,269.241v6.79h-.669v-6.79h.669Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.672,273.059c-.093-.223-.289-.392-.541-.392-.24,0-.465.14-.465.439,0,.278.187.363.625.549.558.233.819.409.969.596.168.204.204.409.204.624,0,.812-.587,1.266-1.332,1.266-.157,0-1.023-.019-1.349-.987l.577-.242c.074.204.299.632.783.632.439,0,.634-.325.634-.615,0-.361-.261-.484-.625-.643-.465-.204-.764-.354-.94-.567-.15-.187-.176-.373-.176-.568,0-.679.475-1.082,1.126-1.082.206,0,.753.038,1.061.7l-.549.289h-.002Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 85.026,
    y: 112.626,
    width: 104.018,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.026,
    y: 143.939,
    width: 104.018,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.026,
    y: 175.251,
    width: 127.728,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.026,
    y: 206.564,
    width: 91.927,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.026,
    y: 237.876,
    width: 100.668,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.026,
    y: 269.189,
    width: 125.66,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.064,
    y: 112.626,
    width: 81.981,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.064,
    y: 143.939,
    width: 81.981,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.064,
    y: 175.251,
    width: 100.668,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.064,
    y: 206.564,
    width: 72.452,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.064,
    y: 237.876,
    width: 79.341,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.064,
    y: 269.189,
    width: 99.038,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.567,
    y: 112.626,
    width: 67.672,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.567,
    y: 143.939,
    width: 67.672,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.567,
    y: 175.251,
    width: 67.672,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.567,
    y: 206.564,
    width: 65.9,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.567,
    y: 237.876,
    width: 65.9,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.567,
    y: 269.189,
    width: 66.577,
    height: 8.26,
    rx: 3.127,
    ry: 3.127,
    style: {
      fill: "#ccc"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.667,32.333c0-.936.477-1.499,1.43-1.69.243-.052.602-.095,1.079-.13.477-.035,1.001-.065,1.573-.091.572-.026,1.092-.039,1.56-.039,2.791,0,4.901.498,6.331,1.495,1.43.997,2.145,2.449,2.145,4.355,0,1.196-.282,2.197-.845,3.003-.563.806-1.4,1.452-2.509,1.937.572.797,1.226,1.833,1.963,3.107.736,1.274,1.486,2.674,2.249,4.199h-3.588c-.225-.502-.511-1.079-.858-1.729s-.707-1.304-1.079-1.963c-.373-.659-.715-1.248-1.027-1.768s-.555-.893-.728-1.118c-.243.035-.538.061-.884.078s-.667.026-.962.026c-.538,0-1.075-.017-1.612-.052-.538-.034-.945-.078-1.222-.13v6.656h-3.016v-16.146ZM91.391,38.574c.815-.537,1.222-1.326,1.222-2.366,0-2.132-1.751-3.198-5.252-3.198-.486,0-.993.018-1.521.052-.529.035-.915.07-1.157.104v6.006c.398.069.849.122,1.352.156.502.035.997.052,1.482.052,1.768,0,3.059-.269,3.874-.806Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.651,48.844c-1.37,0-2.579-.286-3.627-.858-1.049-.572-1.868-1.365-2.457-2.379-.59-1.014-.884-2.197-.884-3.549,0-1.369.303-2.578.91-3.627.606-1.048,1.443-1.872,2.509-2.47,1.066-.598,2.284-.897,3.653-.897,1.664,0,3.012.386,4.043,1.157,1.031.771,1.547,1.825,1.547,3.159,0,1.352-.603,2.366-1.807,3.042-1.205.676-3.116,1.014-5.733,1.014-.243,0-.542-.004-.897-.013-.355-.008-.707-.021-1.053-.039.138.901.602,1.621,1.391,2.158.789.538,1.781.806,2.977.806,1.3,0,2.479-.303,3.536-.91l1.092,2.08c-.381.243-.858.468-1.43.676-.572.208-1.188.368-1.846.481s-1.3.169-1.924.169ZM104.703,37.352c-1.144,0-2.084.369-2.821,1.105-.737.737-1.123,1.703-1.157,2.899.295.018.607.026.936.026h1.3c2.999,0,4.498-.685,4.498-2.054,0-.606-.256-1.087-.767-1.443-.511-.355-1.174-.533-1.989-.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.27,42.578c0-1.577.281-2.925.845-4.043.563-1.118,1.356-1.976,2.379-2.574,1.022-.598,2.236-.897,3.64-.897,1.421,0,2.669.295,3.744.884s1.915,1.404,2.522,2.444c.606,1.04.91,2.228.91,3.562,0,1.318-.295,2.496-.884,3.536-.589,1.04-1.387,1.859-2.392,2.457-1.005.598-2.132.897-3.38.897-.953,0-1.807-.178-2.561-.533-.754-.355-1.374-.845-1.859-1.469v6.838h-2.964v-11.103ZM122.124,45.048c.745-.78,1.118-1.803,1.118-3.068s-.373-2.288-1.118-3.068c-.746-.78-1.708-1.17-2.886-1.17s-2.145.39-2.899,1.17c-.754.78-1.131,1.803-1.131,3.068s.377,2.288,1.131,3.068c.754.78,1.72,1.17,2.899,1.17s2.141-.39,2.886-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.235,45.464c-.633-1.04-.949-2.21-.949-3.51s.316-2.47.949-3.51,1.486-1.863,2.561-2.47c1.075-.606,2.288-.91,3.64-.91s2.569.304,3.653.91c1.083.607,1.938,1.43,2.562,2.47s.936,2.21.936,3.51-.312,2.47-.936,3.51-1.478,1.864-2.562,2.47-2.301.91-3.653.91-2.565-.303-3.64-.91-1.928-1.43-2.561-2.47ZM138.972,44.177c.347-.65.52-1.391.52-2.223s-.173-1.573-.52-2.223c-.347-.65-.828-1.157-1.443-1.521-.616-.364-1.313-.546-2.093-.546s-1.478.182-2.093.546c-.615.364-1.096.871-1.443,1.521-.347.65-.52,1.391-.52,2.223s.173,1.573.52,2.223.828,1.157,1.443,1.521c.615.364,1.313.546,2.093.546s1.478-.182,2.093-.546c.615-.364,1.096-.871,1.443-1.521Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.082,40.082c0-1.577.49-2.808,1.469-3.692.979-.884,2.335-1.326,4.069-1.326,1.178,0,2.088.174,2.73.52.641.347.962.789.962,1.326,0,.277-.074.555-.221.832-.147.277-.291.459-.429.546-.763-.381-1.621-.572-2.574-.572-2.028,0-3.042,1.075-3.042,3.224v7.54h-2.964v-8.398Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.001,33.114c0-.451.147-.793.442-1.027.294-.234.676-.351,1.144-.351.242,0,.494.026.754.078.26.052.468.122.624.208v3.406h3.77c1.04,0,1.56.459,1.56,1.378,0,.503-.113.954-.338,1.352h-4.992v5.772c0,.728.19,1.292.572,1.69s.945.598,1.69.598c.416,0,.845-.061,1.287-.182.442-.121.819-.286,1.131-.494l1.196,1.976c-.451.381-1.062.698-1.833.949-.771.251-1.564.377-2.379.377-1.404,0-2.527-.385-3.367-1.157-.841-.771-1.261-1.815-1.261-3.133v-11.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.18,44.554c0,1.352-.551,2.405-1.651,3.159-1.101.754-2.552,1.131-4.355,1.131-.815,0-1.66-.074-2.535-.221-.875-.147-1.673-.347-2.392-.598-.719-.251-1.27-.516-1.651-.793l1.118-2.002c.554.347,1.317.65,2.288.91.97.26,1.976.39,3.016.39,2.045,0,3.068-.52,3.068-1.56,0-.884-.832-1.43-2.496-1.638l-2.652-.338c-1.318-.173-2.332-.572-3.042-1.196s-1.066-1.491-1.066-2.6c0-1.352.529-2.379,1.586-3.081s2.591-1.053,4.603-1.053c1.057,0,1.993.096,2.808.286.815.191,1.456.447,1.924.767.468.321.702.689.702,1.105,0,.26-.091.529-.273.806-.182.277-.394.477-.637.598-.226-.225-.598-.438-1.118-.637s-1.109-.364-1.768-.494-1.317-.195-1.976-.195c-.919,0-1.634.134-2.145.403-.511.269-.767.663-.767,1.183,0,.399.178.724.533.975.355.251.914.429,1.677.533l2.652.338c3.033.381,4.55,1.655,4.55,3.822Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsDashboard);
export default __webpack_public_path__ + "static/media/ReportsDashboard.7898cdb230968c02d2b261b4d9d820d6.svg";
export { ForwardRef as ReactComponent };